(function () {
  'use strict';

  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }

  function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;

    var _s, _e;

    try {
      for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  function _arrayLikeToArray$1(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }

  function _unsupportedIterableToArray$1(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
  }

  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest();
  }

  function _classCallCheck$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties$1(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass$1(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties$1(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray$1(arr);
  }

  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray$1(arr) || _nonIterableSpread();
  }

  var global$1 = (typeof global !== "undefined" ? global :
    typeof self !== "undefined" ? self :
    typeof window !== "undefined" ? window : {});

  /*! @vimeo/player v2.16.4 | (c) 2022 Vimeo | MIT License | https://github.com/vimeo/player.js */
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  /**
   * @module lib/functions
   */

  /**
   * Check to see this is a node environment.
   * @type {Boolean}
   */

  /* global global */
  var isNode = typeof global$1 !== 'undefined' && {}.toString.call(global$1) === '[object global]';
  /**
   * Get the name of the method for a given getter or setter.
   *
   * @param {string} prop The name of the property.
   * @param {string} type Either “get” or “set”.
   * @return {string}
   */

  function getMethodName(prop, type) {
    if (prop.indexOf(type.toLowerCase()) === 0) {
      return prop;
    }

    return "".concat(type.toLowerCase()).concat(prop.substr(0, 1).toUpperCase()).concat(prop.substr(1));
  }
  /**
   * Check to see if the object is a DOM Element.
   *
   * @param {*} element The object to check.
   * @return {boolean}
   */

  function isDomElement(element) {
    return Boolean(element && element.nodeType === 1 && 'nodeName' in element && element.ownerDocument && element.ownerDocument.defaultView);
  }
  /**
   * Check to see whether the value is a number.
   *
   * @see http://dl.dropboxusercontent.com/u/35146/js/tests/isNumber.html
   * @param {*} value The value to check.
   * @param {boolean} integer Check if the value is an integer.
   * @return {boolean}
   */

  function isInteger(value) {
    // eslint-disable-next-line eqeqeq
    return !isNaN(parseFloat(value)) && isFinite(value) && Math.floor(value) == value;
  }
  /**
   * Check to see if the URL is a Vimeo url.
   *
   * @param {string} url The url string.
   * @return {boolean}
   */

  function isVimeoUrl(url) {
    return /^(https?:)?\/\/((player|www)\.)?vimeo\.com(?=$|\/)/.test(url);
  }
  /**
   * Get the Vimeo URL from an element.
   * The element must have either a data-vimeo-id or data-vimeo-url attribute.
   *
   * @param {object} oEmbedParameters The oEmbed parameters.
   * @return {string}
   */

  function getVimeoUrl() {
    var oEmbedParameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var id = oEmbedParameters.id;
    var url = oEmbedParameters.url;
    var idOrUrl = id || url;

    if (!idOrUrl) {
      throw new Error('An id or url must be passed, either in an options object or as a data-vimeo-id or data-vimeo-url attribute.');
    }

    if (isInteger(idOrUrl)) {
      return "https://vimeo.com/".concat(idOrUrl);
    }

    if (isVimeoUrl(idOrUrl)) {
      return idOrUrl.replace('http:', 'https:');
    }

    if (id) {
      throw new TypeError("\u201C".concat(id, "\u201D is not a valid video id."));
    }

    throw new TypeError("\u201C".concat(idOrUrl, "\u201D is not a vimeo.com url."));
  }

  var arrayIndexOfSupport = typeof Array.prototype.indexOf !== 'undefined';
  var postMessageSupport = typeof window !== 'undefined' && typeof window.postMessage !== 'undefined';

  if (!isNode && (!arrayIndexOfSupport || !postMessageSupport)) {
    throw new Error('Sorry, the Vimeo Player API is not available in this browser.');
  }

  var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global$1 !== 'undefined' ? global$1 : typeof self !== 'undefined' ? self : {};

  function createCommonjsModule(fn, module) {
  	return module = { exports: {} }, fn(module, module.exports), module.exports;
  }

  /*!
   * weakmap-polyfill v2.0.1 - ECMAScript6 WeakMap polyfill
   * https://github.com/polygonplanet/weakmap-polyfill
   * Copyright (c) 2015-2020 Polygon Planet <polygon.planet.aqua@gmail.com>
   * @license MIT
   */
  (function (self) {

    if (self.WeakMap) {
      return;
    }

    var hasOwnProperty = Object.prototype.hasOwnProperty;

    var defineProperty = function (object, name, value) {
      if (Object.defineProperty) {
        Object.defineProperty(object, name, {
          configurable: true,
          writable: true,
          value: value
        });
      } else {
        object[name] = value;
      }
    };

    self.WeakMap = function () {
      // ECMA-262 23.3 WeakMap Objects
      function WeakMap() {
        if (this === void 0) {
          throw new TypeError("Constructor WeakMap requires 'new'");
        }

        defineProperty(this, '_id', genId('_WeakMap')); // ECMA-262 23.3.1.1 WeakMap([iterable])

        if (arguments.length > 0) {
          // Currently, WeakMap `iterable` argument is not supported
          throw new TypeError('WeakMap iterable is not supported');
        }
      } // ECMA-262 23.3.3.2 WeakMap.prototype.delete(key)


      defineProperty(WeakMap.prototype, 'delete', function (key) {
        checkInstance(this, 'delete');

        if (!isObject(key)) {
          return false;
        }

        var entry = key[this._id];

        if (entry && entry[0] === key) {
          delete key[this._id];
          return true;
        }

        return false;
      }); // ECMA-262 23.3.3.3 WeakMap.prototype.get(key)

      defineProperty(WeakMap.prototype, 'get', function (key) {
        checkInstance(this, 'get');

        if (!isObject(key)) {
          return void 0;
        }

        var entry = key[this._id];

        if (entry && entry[0] === key) {
          return entry[1];
        }

        return void 0;
      }); // ECMA-262 23.3.3.4 WeakMap.prototype.has(key)

      defineProperty(WeakMap.prototype, 'has', function (key) {
        checkInstance(this, 'has');

        if (!isObject(key)) {
          return false;
        }

        var entry = key[this._id];

        if (entry && entry[0] === key) {
          return true;
        }

        return false;
      }); // ECMA-262 23.3.3.5 WeakMap.prototype.set(key, value)

      defineProperty(WeakMap.prototype, 'set', function (key, value) {
        checkInstance(this, 'set');

        if (!isObject(key)) {
          throw new TypeError('Invalid value used as weak map key');
        }

        var entry = key[this._id];

        if (entry && entry[0] === key) {
          entry[1] = value;
          return this;
        }

        defineProperty(key, this._id, [key, value]);
        return this;
      });

      function checkInstance(x, methodName) {
        if (!isObject(x) || !hasOwnProperty.call(x, '_id')) {
          throw new TypeError(methodName + ' method called on incompatible receiver ' + typeof x);
        }
      }

      function genId(prefix) {
        return prefix + '_' + rand() + '.' + rand();
      }

      function rand() {
        return Math.random().toString().substring(2);
      }

      defineProperty(WeakMap, '_polyfill', true);
      return WeakMap;
    }();

    function isObject(x) {
      return Object(x) === x;
    }
  })(typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : typeof commonjsGlobal !== 'undefined' ? commonjsGlobal : commonjsGlobal);

  var npo_src = createCommonjsModule(function (module) {
  /*! Native Promise Only
      v0.8.1 (c) Kyle Simpson
      MIT License: http://getify.mit-license.org
  */
  (function UMD(name, context, definition) {
    // special form of UMD for polyfilling across evironments
    context[name] = context[name] || definition();

    if (module.exports) {
      module.exports = context[name];
    }
  })("Promise", typeof commonjsGlobal != "undefined" ? commonjsGlobal : commonjsGlobal, function DEF() {

    var builtInProp,
        cycle,
        scheduling_queue,
        ToString = Object.prototype.toString,
        timer = typeof setImmediate != "undefined" ? function timer(fn) {
      return setImmediate(fn);
    } : setTimeout; // dammit, IE8.

    try {
      Object.defineProperty({}, "x", {});

      builtInProp = function builtInProp(obj, name, val, config) {
        return Object.defineProperty(obj, name, {
          value: val,
          writable: true,
          configurable: config !== false
        });
      };
    } catch (err) {
      builtInProp = function builtInProp(obj, name, val) {
        obj[name] = val;
        return obj;
      };
    } // Note: using a queue instead of array for efficiency


    scheduling_queue = function Queue() {
      var first, last, item;

      function Item(fn, self) {
        this.fn = fn;
        this.self = self;
        this.next = void 0;
      }

      return {
        add: function add(fn, self) {
          item = new Item(fn, self);

          if (last) {
            last.next = item;
          } else {
            first = item;
          }

          last = item;
          item = void 0;
        },
        drain: function drain() {
          var f = first;
          first = last = cycle = void 0;

          while (f) {
            f.fn.call(f.self);
            f = f.next;
          }
        }
      };
    }();

    function schedule(fn, self) {
      scheduling_queue.add(fn, self);

      if (!cycle) {
        cycle = timer(scheduling_queue.drain);
      }
    } // promise duck typing


    function isThenable(o) {
      var _then,
          o_type = typeof o;

      if (o != null && (o_type == "object" || o_type == "function")) {
        _then = o.then;
      }

      return typeof _then == "function" ? _then : false;
    }

    function notify() {
      for (var i = 0; i < this.chain.length; i++) {
        notifyIsolated(this, this.state === 1 ? this.chain[i].success : this.chain[i].failure, this.chain[i]);
      }

      this.chain.length = 0;
    } // NOTE: This is a separate function to isolate
    // the `try..catch` so that other code can be
    // optimized better


    function notifyIsolated(self, cb, chain) {
      var ret, _then;

      try {
        if (cb === false) {
          chain.reject(self.msg);
        } else {
          if (cb === true) {
            ret = self.msg;
          } else {
            ret = cb.call(void 0, self.msg);
          }

          if (ret === chain.promise) {
            chain.reject(TypeError("Promise-chain cycle"));
          } else if (_then = isThenable(ret)) {
            _then.call(ret, chain.resolve, chain.reject);
          } else {
            chain.resolve(ret);
          }
        }
      } catch (err) {
        chain.reject(err);
      }
    }

    function resolve(msg) {
      var _then,
          self = this; // already triggered?


      if (self.triggered) {
        return;
      }

      self.triggered = true; // unwrap

      if (self.def) {
        self = self.def;
      }

      try {
        if (_then = isThenable(msg)) {
          schedule(function () {
            var def_wrapper = new MakeDefWrapper(self);

            try {
              _then.call(msg, function $resolve$() {
                resolve.apply(def_wrapper, arguments);
              }, function $reject$() {
                reject.apply(def_wrapper, arguments);
              });
            } catch (err) {
              reject.call(def_wrapper, err);
            }
          });
        } else {
          self.msg = msg;
          self.state = 1;

          if (self.chain.length > 0) {
            schedule(notify, self);
          }
        }
      } catch (err) {
        reject.call(new MakeDefWrapper(self), err);
      }
    }

    function reject(msg) {
      var self = this; // already triggered?

      if (self.triggered) {
        return;
      }

      self.triggered = true; // unwrap

      if (self.def) {
        self = self.def;
      }

      self.msg = msg;
      self.state = 2;

      if (self.chain.length > 0) {
        schedule(notify, self);
      }
    }

    function iteratePromises(Constructor, arr, resolver, rejecter) {
      for (var idx = 0; idx < arr.length; idx++) {
        (function IIFE(idx) {
          Constructor.resolve(arr[idx]).then(function $resolver$(msg) {
            resolver(idx, msg);
          }, rejecter);
        })(idx);
      }
    }

    function MakeDefWrapper(self) {
      this.def = self;
      this.triggered = false;
    }

    function MakeDef(self) {
      this.promise = self;
      this.state = 0;
      this.triggered = false;
      this.chain = [];
      this.msg = void 0;
    }

    function Promise(executor) {
      if (typeof executor != "function") {
        throw TypeError("Not a function");
      }

      if (this.__NPO__ !== 0) {
        throw TypeError("Not a promise");
      } // instance shadowing the inherited "brand"
      // to signal an already "initialized" promise


      this.__NPO__ = 1;
      var def = new MakeDef(this);

      this["then"] = function then(success, failure) {
        var o = {
          success: typeof success == "function" ? success : true,
          failure: typeof failure == "function" ? failure : false
        }; // Note: `then(..)` itself can be borrowed to be used against
        // a different promise constructor for making the chained promise,
        // by substituting a different `this` binding.

        o.promise = new this.constructor(function extractChain(resolve, reject) {
          if (typeof resolve != "function" || typeof reject != "function") {
            throw TypeError("Not a function");
          }

          o.resolve = resolve;
          o.reject = reject;
        });
        def.chain.push(o);

        if (def.state !== 0) {
          schedule(notify, def);
        }

        return o.promise;
      };

      this["catch"] = function $catch$(failure) {
        return this.then(void 0, failure);
      };

      try {
        executor.call(void 0, function publicResolve(msg) {
          resolve.call(def, msg);
        }, function publicReject(msg) {
          reject.call(def, msg);
        });
      } catch (err) {
        reject.call(def, err);
      }
    }

    var PromisePrototype = builtInProp({}, "constructor", Promise,
    /*configurable=*/
    false); // Note: Android 4 cannot use `Object.defineProperty(..)` here

    Promise.prototype = PromisePrototype; // built-in "brand" to signal an "uninitialized" promise

    builtInProp(PromisePrototype, "__NPO__", 0,
    /*configurable=*/
    false);
    builtInProp(Promise, "resolve", function Promise$resolve(msg) {
      var Constructor = this; // spec mandated checks
      // note: best "isPromise" check that's practical for now

      if (msg && typeof msg == "object" && msg.__NPO__ === 1) {
        return msg;
      }

      return new Constructor(function executor(resolve, reject) {
        if (typeof resolve != "function" || typeof reject != "function") {
          throw TypeError("Not a function");
        }

        resolve(msg);
      });
    });
    builtInProp(Promise, "reject", function Promise$reject(msg) {
      return new this(function executor(resolve, reject) {
        if (typeof resolve != "function" || typeof reject != "function") {
          throw TypeError("Not a function");
        }

        reject(msg);
      });
    });
    builtInProp(Promise, "all", function Promise$all(arr) {
      var Constructor = this; // spec mandated checks

      if (ToString.call(arr) != "[object Array]") {
        return Constructor.reject(TypeError("Not an array"));
      }

      if (arr.length === 0) {
        return Constructor.resolve([]);
      }

      return new Constructor(function executor(resolve, reject) {
        if (typeof resolve != "function" || typeof reject != "function") {
          throw TypeError("Not a function");
        }

        var len = arr.length,
            msgs = Array(len),
            count = 0;
        iteratePromises(Constructor, arr, function resolver(idx, msg) {
          msgs[idx] = msg;

          if (++count === len) {
            resolve(msgs);
          }
        }, reject);
      });
    });
    builtInProp(Promise, "race", function Promise$race(arr) {
      var Constructor = this; // spec mandated checks

      if (ToString.call(arr) != "[object Array]") {
        return Constructor.reject(TypeError("Not an array"));
      }

      return new Constructor(function executor(resolve, reject) {
        if (typeof resolve != "function" || typeof reject != "function") {
          throw TypeError("Not a function");
        }

        iteratePromises(Constructor, arr, function resolver(idx, msg) {
          resolve(msg);
        }, reject);
      });
    });
    return Promise;
  });
  });

  /**
   * @module lib/callbacks
   */
  var callbackMap = new WeakMap();
  /**
   * Store a callback for a method or event for a player.
   *
   * @param {Player} player The player object.
   * @param {string} name The method or event name.
   * @param {(function(this:Player, *): void|{resolve: function, reject: function})} callback
   *        The callback to call or an object with resolve and reject functions for a promise.
   * @return {void}
   */

  function storeCallback(player, name, callback) {
    var playerCallbacks = callbackMap.get(player.element) || {};

    if (!(name in playerCallbacks)) {
      playerCallbacks[name] = [];
    }

    playerCallbacks[name].push(callback);
    callbackMap.set(player.element, playerCallbacks);
  }
  /**
   * Get the callbacks for a player and event or method.
   *
   * @param {Player} player The player object.
   * @param {string} name The method or event name
   * @return {function[]}
   */

  function getCallbacks(player, name) {
    var playerCallbacks = callbackMap.get(player.element) || {};
    return playerCallbacks[name] || [];
  }
  /**
   * Remove a stored callback for a method or event for a player.
   *
   * @param {Player} player The player object.
   * @param {string} name The method or event name
   * @param {function} [callback] The specific callback to remove.
   * @return {boolean} Was this the last callback?
   */

  function removeCallback(player, name, callback) {
    var playerCallbacks = callbackMap.get(player.element) || {};

    if (!playerCallbacks[name]) {
      return true;
    } // If no callback is passed, remove all callbacks for the event


    if (!callback) {
      playerCallbacks[name] = [];
      callbackMap.set(player.element, playerCallbacks);
      return true;
    }

    var index = playerCallbacks[name].indexOf(callback);

    if (index !== -1) {
      playerCallbacks[name].splice(index, 1);
    }

    callbackMap.set(player.element, playerCallbacks);
    return playerCallbacks[name] && playerCallbacks[name].length === 0;
  }
  /**
   * Return the first stored callback for a player and event or method.
   *
   * @param {Player} player The player object.
   * @param {string} name The method or event name.
   * @return {function} The callback, or false if there were none
   */

  function shiftCallbacks(player, name) {
    var playerCallbacks = getCallbacks(player, name);

    if (playerCallbacks.length < 1) {
      return false;
    }

    var callback = playerCallbacks.shift();
    removeCallback(player, name, callback);
    return callback;
  }
  /**
   * Move callbacks associated with an element to another element.
   *
   * @param {HTMLElement} oldElement The old element.
   * @param {HTMLElement} newElement The new element.
   * @return {void}
   */

  function swapCallbacks(oldElement, newElement) {
    var playerCallbacks = callbackMap.get(oldElement);
    callbackMap.set(newElement, playerCallbacks);
    callbackMap.delete(oldElement);
  }

  /**
   * @module lib/embed
   */
  var oEmbedParameters = ['autopause', 'autoplay', 'background', 'byline', 'color', 'controls', 'dnt', 'height', 'id', 'interactive_params', 'keyboard', 'loop', 'maxheight', 'maxwidth', 'muted', 'playsinline', 'portrait', 'responsive', 'speed', 'texttrack', 'title', 'transparent', 'url', 'width'];
  /**
   * Get the 'data-vimeo'-prefixed attributes from an element as an object.
   *
   * @param {HTMLElement} element The element.
   * @param {Object} [defaults={}] The default values to use.
   * @return {Object<string, string>}
   */

  function getOEmbedParameters(element) {
    var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return oEmbedParameters.reduce(function (params, param) {
      var value = element.getAttribute("data-vimeo-".concat(param));

      if (value || value === '') {
        params[param] = value === '' ? 1 : value;
      }

      return params;
    }, defaults);
  }
  /**
   * Create an embed from oEmbed data inside an element.
   *
   * @param {object} data The oEmbed data.
   * @param {HTMLElement} element The element to put the iframe in.
   * @return {HTMLIFrameElement} The iframe embed.
   */

  function createEmbed(_ref, element) {
    var html = _ref.html;

    if (!element) {
      throw new TypeError('An element must be provided');
    }

    if (element.getAttribute('data-vimeo-initialized') !== null) {
      return element.querySelector('iframe');
    }

    var div = document.createElement('div');
    div.innerHTML = html;
    element.appendChild(div.firstChild);
    element.setAttribute('data-vimeo-initialized', 'true');
    return element.querySelector('iframe');
  }
  /**
   * Make an oEmbed call for the specified URL.
   *
   * @param {string} videoUrl The vimeo.com url for the video.
   * @param {Object} [params] Parameters to pass to oEmbed.
   * @param {HTMLElement} element The element.
   * @return {Promise}
   */

  function getOEmbedData(videoUrl) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var element = arguments.length > 2 ? arguments[2] : undefined;
    return new Promise(function (resolve, reject) {
      if (!isVimeoUrl(videoUrl)) {
        throw new TypeError("\u201C".concat(videoUrl, "\u201D is not a vimeo.com url."));
      }

      var url = "https://vimeo.com/api/oembed.json?url=".concat(encodeURIComponent(videoUrl));

      for (var param in params) {
        if (params.hasOwnProperty(param)) {
          url += "&".concat(param, "=").concat(encodeURIComponent(params[param]));
        }
      }

      var xhr = 'XDomainRequest' in window ? new XDomainRequest() : new XMLHttpRequest();
      xhr.open('GET', url, true);

      xhr.onload = function () {
        if (xhr.status === 404) {
          reject(new Error("\u201C".concat(videoUrl, "\u201D was not found.")));
          return;
        }

        if (xhr.status === 403) {
          reject(new Error("\u201C".concat(videoUrl, "\u201D is not embeddable.")));
          return;
        }

        try {
          var json = JSON.parse(xhr.responseText); // Check api response for 403 on oembed

          if (json.domain_status_code === 403) {
            // We still want to create the embed to give users visual feedback
            createEmbed(json, element);
            reject(new Error("\u201C".concat(videoUrl, "\u201D is not embeddable.")));
            return;
          }

          resolve(json);
        } catch (error) {
          reject(error);
        }
      };

      xhr.onerror = function () {
        var status = xhr.status ? " (".concat(xhr.status, ")") : '';
        reject(new Error("There was an error fetching the embed code from Vimeo".concat(status, ".")));
      };

      xhr.send();
    });
  }
  /**
   * Initialize all embeds within a specific element
   *
   * @param {HTMLElement} [parent=document] The parent element.
   * @return {void}
   */

  function initializeEmbeds() {
    var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    var elements = [].slice.call(parent.querySelectorAll('[data-vimeo-id], [data-vimeo-url]'));

    var handleError = function handleError(error) {
      if ('console' in window && console.error) {
        console.error("There was an error creating an embed: ".concat(error));
      }
    };

    elements.forEach(function (element) {
      try {
        // Skip any that have data-vimeo-defer
        if (element.getAttribute('data-vimeo-defer') !== null) {
          return;
        }

        var params = getOEmbedParameters(element);
        var url = getVimeoUrl(params);
        getOEmbedData(url, params, element).then(function (data) {
          return createEmbed(data, element);
        }).catch(handleError);
      } catch (error) {
        handleError(error);
      }
    });
  }
  /**
   * Resize embeds when messaged by the player.
   *
   * @param {HTMLElement} [parent=document] The parent element.
   * @return {void}
   */

  function resizeEmbeds() {
    var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

    // Prevent execution if users include the player.js script multiple times.
    if (window.VimeoPlayerResizeEmbeds_) {
      return;
    }

    window.VimeoPlayerResizeEmbeds_ = true;

    var onMessage = function onMessage(event) {
      if (!isVimeoUrl(event.origin)) {
        return;
      } // 'spacechange' is fired only on embeds with cards


      if (!event.data || event.data.event !== 'spacechange') {
        return;
      }

      var iframes = parent.querySelectorAll('iframe');

      for (var i = 0; i < iframes.length; i++) {
        if (iframes[i].contentWindow !== event.source) {
          continue;
        } // Change padding-bottom of the enclosing div to accommodate
        // card carousel without distorting aspect ratio


        var space = iframes[i].parentElement;
        space.style.paddingBottom = "".concat(event.data.data[0].bottom, "px");
        break;
      }
    };

    window.addEventListener('message', onMessage);
  }

  /**
   * @module lib/postmessage
   */
  /**
   * Parse a message received from postMessage.
   *
   * @param {*} data The data received from postMessage.
   * @return {object}
   */

  function parseMessageData(data) {
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (error) {
        // If the message cannot be parsed, throw the error as a warning
        console.warn(error);
        return {};
      }
    }

    return data;
  }
  /**
   * Post a message to the specified target.
   *
   * @param {Player} player The player object to use.
   * @param {string} method The API method to call.
   * @param {object} params The parameters to send to the player.
   * @return {void}
   */

  function postMessage(player, method, params) {
    if (!player.element.contentWindow || !player.element.contentWindow.postMessage) {
      return;
    }

    var message = {
      method: method
    };

    if (params !== undefined) {
      message.value = params;
    } // IE 8 and 9 do not support passing messages, so stringify them


    var ieVersion = parseFloat(navigator.userAgent.toLowerCase().replace(/^.*msie (\d+).*$/, '$1'));

    if (ieVersion >= 8 && ieVersion < 10) {
      message = JSON.stringify(message);
    }

    player.element.contentWindow.postMessage(message, player.origin);
  }
  /**
   * Parse the data received from a message event.
   *
   * @param {Player} player The player that received the message.
   * @param {(Object|string)} data The message data. Strings will be parsed into JSON.
   * @return {void}
   */

  function processData(player, data) {
    data = parseMessageData(data);
    var callbacks = [];
    var param;

    if (data.event) {
      if (data.event === 'error') {
        var promises = getCallbacks(player, data.data.method);
        promises.forEach(function (promise) {
          var error = new Error(data.data.message);
          error.name = data.data.name;
          promise.reject(error);
          removeCallback(player, data.data.method, promise);
        });
      }

      callbacks = getCallbacks(player, "event:".concat(data.event));
      param = data.data;
    } else if (data.method) {
      var callback = shiftCallbacks(player, data.method);

      if (callback) {
        callbacks.push(callback);
        param = data.value;
      }
    }

    callbacks.forEach(function (callback) {
      try {
        if (typeof callback === 'function') {
          callback.call(player, param);
          return;
        }

        callback.resolve(param);
      } catch (e) {// empty
      }
    });
  }

  /* MIT License

  Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)

  Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
  Terms */
  function initializeScreenfull() {
    var fn = function () {
      var val;
      var fnMap = [['requestFullscreen', 'exitFullscreen', 'fullscreenElement', 'fullscreenEnabled', 'fullscreenchange', 'fullscreenerror'], // New WebKit
      ['webkitRequestFullscreen', 'webkitExitFullscreen', 'webkitFullscreenElement', 'webkitFullscreenEnabled', 'webkitfullscreenchange', 'webkitfullscreenerror'], // Old WebKit
      ['webkitRequestFullScreen', 'webkitCancelFullScreen', 'webkitCurrentFullScreenElement', 'webkitCancelFullScreen', 'webkitfullscreenchange', 'webkitfullscreenerror'], ['mozRequestFullScreen', 'mozCancelFullScreen', 'mozFullScreenElement', 'mozFullScreenEnabled', 'mozfullscreenchange', 'mozfullscreenerror'], ['msRequestFullscreen', 'msExitFullscreen', 'msFullscreenElement', 'msFullscreenEnabled', 'MSFullscreenChange', 'MSFullscreenError']];
      var i = 0;
      var l = fnMap.length;
      var ret = {};

      for (; i < l; i++) {
        val = fnMap[i];

        if (val && val[1] in document) {
          for (i = 0; i < val.length; i++) {
            ret[fnMap[0][i]] = val[i];
          }

          return ret;
        }
      }

      return false;
    }();

    var eventNameMap = {
      fullscreenchange: fn.fullscreenchange,
      fullscreenerror: fn.fullscreenerror
    };
    var screenfull = {
      request: function request(element) {
        return new Promise(function (resolve, reject) {
          var onFullScreenEntered = function onFullScreenEntered() {
            screenfull.off('fullscreenchange', onFullScreenEntered);
            resolve();
          };

          screenfull.on('fullscreenchange', onFullScreenEntered);
          element = element || document.documentElement;
          var returnPromise = element[fn.requestFullscreen]();

          if (returnPromise instanceof Promise) {
            returnPromise.then(onFullScreenEntered).catch(reject);
          }
        });
      },
      exit: function exit() {
        return new Promise(function (resolve, reject) {
          if (!screenfull.isFullscreen) {
            resolve();
            return;
          }

          var onFullScreenExit = function onFullScreenExit() {
            screenfull.off('fullscreenchange', onFullScreenExit);
            resolve();
          };

          screenfull.on('fullscreenchange', onFullScreenExit);
          var returnPromise = document[fn.exitFullscreen]();

          if (returnPromise instanceof Promise) {
            returnPromise.then(onFullScreenExit).catch(reject);
          }
        });
      },
      on: function on(event, callback) {
        var eventName = eventNameMap[event];

        if (eventName) {
          document.addEventListener(eventName, callback);
        }
      },
      off: function off(event, callback) {
        var eventName = eventNameMap[event];

        if (eventName) {
          document.removeEventListener(eventName, callback);
        }
      }
    };
    Object.defineProperties(screenfull, {
      isFullscreen: {
        get: function get() {
          return Boolean(document[fn.fullscreenElement]);
        }
      },
      element: {
        enumerable: true,
        get: function get() {
          return document[fn.fullscreenElement];
        }
      },
      isEnabled: {
        enumerable: true,
        get: function get() {
          // Coerce to boolean in case of old WebKit
          return Boolean(document[fn.fullscreenEnabled]);
        }
      }
    });
    return screenfull;
  }

  var playerMap = new WeakMap();
  var readyMap = new WeakMap();
  var screenfull = {};

  var Player = /*#__PURE__*/function () {
    /**
     * Create a Player.
     *
     * @param {(HTMLIFrameElement|HTMLElement|string|jQuery)} element A reference to the Vimeo
     *        player iframe, and id, or a jQuery object.
     * @param {object} [options] oEmbed parameters to use when creating an embed in the element.
     * @return {Player}
     */
    function Player(element) {
      var _this = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      _classCallCheck(this, Player);

      /* global jQuery */
      if (window.jQuery && element instanceof jQuery) {
        if (element.length > 1 && window.console && console.warn) {
          console.warn('A jQuery object with multiple elements was passed, using the first element.');
        }

        element = element[0];
      } // Find an element by ID


      if (typeof document !== 'undefined' && typeof element === 'string') {
        element = document.getElementById(element);
      } // Not an element!


      if (!isDomElement(element)) {
        throw new TypeError('You must pass either a valid element or a valid id.');
      } // Already initialized an embed in this div, so grab the iframe


      if (element.nodeName !== 'IFRAME') {
        var iframe = element.querySelector('iframe');

        if (iframe) {
          element = iframe;
        }
      } // iframe url is not a Vimeo url


      if (element.nodeName === 'IFRAME' && !isVimeoUrl(element.getAttribute('src') || '')) {
        throw new Error('The player element passed isn’t a Vimeo embed.');
      } // If there is already a player object in the map, return that


      if (playerMap.has(element)) {
        return playerMap.get(element);
      }

      this._window = element.ownerDocument.defaultView;
      this.element = element;
      this.origin = '*';
      var readyPromise = new npo_src(function (resolve, reject) {
        _this._onMessage = function (event) {
          if (!isVimeoUrl(event.origin) || _this.element.contentWindow !== event.source) {
            return;
          }

          if (_this.origin === '*') {
            _this.origin = event.origin;
          }

          var data = parseMessageData(event.data);
          var isError = data && data.event === 'error';
          var isReadyError = isError && data.data && data.data.method === 'ready';

          if (isReadyError) {
            var error = new Error(data.data.message);
            error.name = data.data.name;
            reject(error);
            return;
          }

          var isReadyEvent = data && data.event === 'ready';
          var isPingResponse = data && data.method === 'ping';

          if (isReadyEvent || isPingResponse) {
            _this.element.setAttribute('data-ready', 'true');

            resolve();
            return;
          }

          processData(_this, data);
        };

        _this._window.addEventListener('message', _this._onMessage);

        if (_this.element.nodeName !== 'IFRAME') {
          var params = getOEmbedParameters(element, options);
          var url = getVimeoUrl(params);
          getOEmbedData(url, params, element).then(function (data) {
            var iframe = createEmbed(data, element); // Overwrite element with the new iframe,
            // but store reference to the original element

            _this.element = iframe;
            _this._originalElement = element;
            swapCallbacks(element, iframe);
            playerMap.set(_this.element, _this);
            return data;
          }).catch(reject);
        }
      }); // Store a copy of this Player in the map

      readyMap.set(this, readyPromise);
      playerMap.set(this.element, this); // Send a ping to the iframe so the ready promise will be resolved if
      // the player is already ready.

      if (this.element.nodeName === 'IFRAME') {
        postMessage(this, 'ping');
      }

      if (screenfull.isEnabled) {
        var exitFullscreen = function exitFullscreen() {
          return screenfull.exit();
        };

        this.fullscreenchangeHandler = function () {
          if (screenfull.isFullscreen) {
            storeCallback(_this, 'event:exitFullscreen', exitFullscreen);
          } else {
            removeCallback(_this, 'event:exitFullscreen', exitFullscreen);
          } // eslint-disable-next-line


          _this.ready().then(function () {
            postMessage(_this, 'fullscreenchange', screenfull.isFullscreen);
          });
        };

        screenfull.on('fullscreenchange', this.fullscreenchangeHandler);
      }

      return this;
    }
    /**
     * Get a promise for a method.
     *
     * @param {string} name The API method to call.
     * @param {Object} [args={}] Arguments to send via postMessage.
     * @return {Promise}
     */


    _createClass(Player, [{
      key: "callMethod",
      value: function callMethod(name) {
        var _this2 = this;

        var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return new npo_src(function (resolve, reject) {
          // We are storing the resolve/reject handlers to call later, so we
          // can’t return here.
          // eslint-disable-next-line promise/always-return
          return _this2.ready().then(function () {
            storeCallback(_this2, name, {
              resolve: resolve,
              reject: reject
            });
            postMessage(_this2, name, args);
          }).catch(reject);
        });
      }
      /**
       * Get a promise for the value of a player property.
       *
       * @param {string} name The property name
       * @return {Promise}
       */

    }, {
      key: "get",
      value: function get(name) {
        var _this3 = this;

        return new npo_src(function (resolve, reject) {
          name = getMethodName(name, 'get'); // We are storing the resolve/reject handlers to call later, so we
          // can’t return here.
          // eslint-disable-next-line promise/always-return

          return _this3.ready().then(function () {
            storeCallback(_this3, name, {
              resolve: resolve,
              reject: reject
            });
            postMessage(_this3, name);
          }).catch(reject);
        });
      }
      /**
       * Get a promise for setting the value of a player property.
       *
       * @param {string} name The API method to call.
       * @param {mixed} value The value to set.
       * @return {Promise}
       */

    }, {
      key: "set",
      value: function set(name, value) {
        var _this4 = this;

        return new npo_src(function (resolve, reject) {
          name = getMethodName(name, 'set');

          if (value === undefined || value === null) {
            throw new TypeError('There must be a value to set.');
          } // We are storing the resolve/reject handlers to call later, so we
          // can’t return here.
          // eslint-disable-next-line promise/always-return


          return _this4.ready().then(function () {
            storeCallback(_this4, name, {
              resolve: resolve,
              reject: reject
            });
            postMessage(_this4, name, value);
          }).catch(reject);
        });
      }
      /**
       * Add an event listener for the specified event. Will call the
       * callback with a single parameter, `data`, that contains the data for
       * that event.
       *
       * @param {string} eventName The name of the event.
       * @param {function(*)} callback The function to call when the event fires.
       * @return {void}
       */

    }, {
      key: "on",
      value: function on(eventName, callback) {
        if (!eventName) {
          throw new TypeError('You must pass an event name.');
        }

        if (!callback) {
          throw new TypeError('You must pass a callback function.');
        }

        if (typeof callback !== 'function') {
          throw new TypeError('The callback must be a function.');
        }

        var callbacks = getCallbacks(this, "event:".concat(eventName));

        if (callbacks.length === 0) {
          this.callMethod('addEventListener', eventName).catch(function () {// Ignore the error. There will be an error event fired that
            // will trigger the error callback if they are listening.
          });
        }

        storeCallback(this, "event:".concat(eventName), callback);
      }
      /**
       * Remove an event listener for the specified event. Will remove all
       * listeners for that event if a `callback` isn’t passed, or only that
       * specific callback if it is passed.
       *
       * @param {string} eventName The name of the event.
       * @param {function} [callback] The specific callback to remove.
       * @return {void}
       */

    }, {
      key: "off",
      value: function off(eventName, callback) {
        if (!eventName) {
          throw new TypeError('You must pass an event name.');
        }

        if (callback && typeof callback !== 'function') {
          throw new TypeError('The callback must be a function.');
        }

        var lastCallback = removeCallback(this, "event:".concat(eventName), callback); // If there are no callbacks left, remove the listener

        if (lastCallback) {
          this.callMethod('removeEventListener', eventName).catch(function (e) {// Ignore the error. There will be an error event fired that
            // will trigger the error callback if they are listening.
          });
        }
      }
      /**
       * A promise to load a new video.
       *
       * @promise LoadVideoPromise
       * @fulfill {number} The video with this id or url successfully loaded.
       * @reject {TypeError} The id was not a number.
       */

      /**
       * Load a new video into this embed. The promise will be resolved if
       * the video is successfully loaded, or it will be rejected if it could
       * not be loaded.
       *
       * @param {number|string|object} options The id of the video, the url of the video, or an object with embed options.
       * @return {LoadVideoPromise}
       */

    }, {
      key: "loadVideo",
      value: function loadVideo(options) {
        return this.callMethod('loadVideo', options);
      }
      /**
       * A promise to perform an action when the Player is ready.
       *
       * @todo document errors
       * @promise LoadVideoPromise
       * @fulfill {void}
       */

      /**
       * Trigger a function when the player iframe has initialized. You do not
       * need to wait for `ready` to trigger to begin adding event listeners
       * or calling other methods.
       *
       * @return {ReadyPromise}
       */

    }, {
      key: "ready",
      value: function ready() {
        var readyPromise = readyMap.get(this) || new npo_src(function (resolve, reject) {
          reject(new Error('Unknown player. Probably unloaded.'));
        });
        return npo_src.resolve(readyPromise);
      }
      /**
       * A promise to add a cue point to the player.
       *
       * @promise AddCuePointPromise
       * @fulfill {string} The id of the cue point to use for removeCuePoint.
       * @reject {RangeError} the time was less than 0 or greater than the
       *         video’s duration.
       * @reject {UnsupportedError} Cue points are not supported with the current
       *         player or browser.
       */

      /**
       * Add a cue point to the player.
       *
       * @param {number} time The time for the cue point.
       * @param {object} [data] Arbitrary data to be returned with the cue point.
       * @return {AddCuePointPromise}
       */

    }, {
      key: "addCuePoint",
      value: function addCuePoint(time) {
        var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.callMethod('addCuePoint', {
          time: time,
          data: data
        });
      }
      /**
       * A promise to remove a cue point from the player.
       *
       * @promise AddCuePointPromise
       * @fulfill {string} The id of the cue point that was removed.
       * @reject {InvalidCuePoint} The cue point with the specified id was not
       *         found.
       * @reject {UnsupportedError} Cue points are not supported with the current
       *         player or browser.
       */

      /**
       * Remove a cue point from the video.
       *
       * @param {string} id The id of the cue point to remove.
       * @return {RemoveCuePointPromise}
       */

    }, {
      key: "removeCuePoint",
      value: function removeCuePoint(id) {
        return this.callMethod('removeCuePoint', id);
      }
      /**
       * A representation of a text track on a video.
       *
       * @typedef {Object} VimeoTextTrack
       * @property {string} language The ISO language code.
       * @property {string} kind The kind of track it is (captions or subtitles).
       * @property {string} label The human‐readable label for the track.
       */

      /**
       * A promise to enable a text track.
       *
       * @promise EnableTextTrackPromise
       * @fulfill {VimeoTextTrack} The text track that was enabled.
       * @reject {InvalidTrackLanguageError} No track was available with the
       *         specified language.
       * @reject {InvalidTrackError} No track was available with the specified
       *         language and kind.
       */

      /**
       * Enable the text track with the specified language, and optionally the
       * specified kind (captions or subtitles).
       *
       * When set via the API, the track language will not change the viewer’s
       * stored preference.
       *
       * @param {string} language The two‐letter language code.
       * @param {string} [kind] The kind of track to enable (captions or subtitles).
       * @return {EnableTextTrackPromise}
       */

    }, {
      key: "enableTextTrack",
      value: function enableTextTrack(language, kind) {
        if (!language) {
          throw new TypeError('You must pass a language.');
        }

        return this.callMethod('enableTextTrack', {
          language: language,
          kind: kind
        });
      }
      /**
       * A promise to disable the active text track.
       *
       * @promise DisableTextTrackPromise
       * @fulfill {void} The track was disabled.
       */

      /**
       * Disable the currently-active text track.
       *
       * @return {DisableTextTrackPromise}
       */

    }, {
      key: "disableTextTrack",
      value: function disableTextTrack() {
        return this.callMethod('disableTextTrack');
      }
      /**
       * A promise to pause the video.
       *
       * @promise PausePromise
       * @fulfill {void} The video was paused.
       */

      /**
       * Pause the video if it’s playing.
       *
       * @return {PausePromise}
       */

    }, {
      key: "pause",
      value: function pause() {
        return this.callMethod('pause');
      }
      /**
       * A promise to play the video.
       *
       * @promise PlayPromise
       * @fulfill {void} The video was played.
       */

      /**
       * Play the video if it’s paused. **Note:** on iOS and some other
       * mobile devices, you cannot programmatically trigger play. Once the
       * viewer has tapped on the play button in the player, however, you
       * will be able to use this function.
       *
       * @return {PlayPromise}
       */

    }, {
      key: "play",
      value: function play() {
        return this.callMethod('play');
      }
      /**
       * Request that the player enters fullscreen.
       * @return {Promise}
       */

    }, {
      key: "requestFullscreen",
      value: function requestFullscreen() {
        if (screenfull.isEnabled) {
          return screenfull.request(this.element);
        }

        return this.callMethod('requestFullscreen');
      }
      /**
       * Request that the player exits fullscreen.
       * @return {Promise}
       */

    }, {
      key: "exitFullscreen",
      value: function exitFullscreen() {
        if (screenfull.isEnabled) {
          return screenfull.exit();
        }

        return this.callMethod('exitFullscreen');
      }
      /**
       * Returns true if the player is currently fullscreen.
       * @return {Promise}
       */

    }, {
      key: "getFullscreen",
      value: function getFullscreen() {
        if (screenfull.isEnabled) {
          return npo_src.resolve(screenfull.isFullscreen);
        }

        return this.get('fullscreen');
      }
      /**
       * Request that the player enters picture-in-picture.
       * @return {Promise}
       */

    }, {
      key: "requestPictureInPicture",
      value: function requestPictureInPicture() {
        return this.callMethod('requestPictureInPicture');
      }
      /**
       * Request that the player exits picture-in-picture.
       * @return {Promise}
       */

    }, {
      key: "exitPictureInPicture",
      value: function exitPictureInPicture() {
        return this.callMethod('exitPictureInPicture');
      }
      /**
       * Returns true if the player is currently picture-in-picture.
       * @return {Promise}
       */

    }, {
      key: "getPictureInPicture",
      value: function getPictureInPicture() {
        return this.get('pictureInPicture');
      }
      /**
       * A promise to unload the video.
       *
       * @promise UnloadPromise
       * @fulfill {void} The video was unloaded.
       */

      /**
       * Return the player to its initial state.
       *
       * @return {UnloadPromise}
       */

    }, {
      key: "unload",
      value: function unload() {
        return this.callMethod('unload');
      }
      /**
       * Cleanup the player and remove it from the DOM
       *
       * It won't be usable and a new one should be constructed
       *  in order to do any operations.
       *
       * @return {Promise}
       */

    }, {
      key: "destroy",
      value: function destroy() {
        var _this5 = this;

        return new npo_src(function (resolve) {
          readyMap.delete(_this5);
          playerMap.delete(_this5.element);

          if (_this5._originalElement) {
            playerMap.delete(_this5._originalElement);

            _this5._originalElement.removeAttribute('data-vimeo-initialized');
          }

          if (_this5.element && _this5.element.nodeName === 'IFRAME' && _this5.element.parentNode) {
            // If we've added an additional wrapper div, remove that from the DOM.
            // If not, just remove the iframe element.
            if (_this5.element.parentNode.parentNode && _this5._originalElement && _this5._originalElement !== _this5.element.parentNode) {
              _this5.element.parentNode.parentNode.removeChild(_this5.element.parentNode);
            } else {
              _this5.element.parentNode.removeChild(_this5.element);
            }
          } // If the clip is private there is a case where the element stays the
          // div element. Destroy should reset the div and remove the iframe child.


          if (_this5.element && _this5.element.nodeName === 'DIV' && _this5.element.parentNode) {
            _this5.element.removeAttribute('data-vimeo-initialized');

            var iframe = _this5.element.querySelector('iframe');

            if (iframe && iframe.parentNode) {
              // If we've added an additional wrapper div, remove that from the DOM.
              // If not, just remove the iframe element.
              if (iframe.parentNode.parentNode && _this5._originalElement && _this5._originalElement !== iframe.parentNode) {
                iframe.parentNode.parentNode.removeChild(iframe.parentNode);
              } else {
                iframe.parentNode.removeChild(iframe);
              }
            }
          }

          _this5._window.removeEventListener('message', _this5._onMessage);

          if (screenfull.isEnabled) {
            screenfull.off('fullscreenchange', _this5.fullscreenchangeHandler);
          }

          resolve();
        });
      }
      /**
       * A promise to get the autopause behavior of the video.
       *
       * @promise GetAutopausePromise
       * @fulfill {boolean} Whether autopause is turned on or off.
       * @reject {UnsupportedError} Autopause is not supported with the current
       *         player or browser.
       */

      /**
       * Get the autopause behavior for this player.
       *
       * @return {GetAutopausePromise}
       */

    }, {
      key: "getAutopause",
      value: function getAutopause() {
        return this.get('autopause');
      }
      /**
       * A promise to set the autopause behavior of the video.
       *
       * @promise SetAutopausePromise
       * @fulfill {boolean} Whether autopause is turned on or off.
       * @reject {UnsupportedError} Autopause is not supported with the current
       *         player or browser.
       */

      /**
       * Enable or disable the autopause behavior of this player.
       *
       * By default, when another video is played in the same browser, this
       * player will automatically pause. Unless you have a specific reason
       * for doing so, we recommend that you leave autopause set to the
       * default (`true`).
       *
       * @param {boolean} autopause
       * @return {SetAutopausePromise}
       */

    }, {
      key: "setAutopause",
      value: function setAutopause(autopause) {
        return this.set('autopause', autopause);
      }
      /**
       * A promise to get the buffered property of the video.
       *
       * @promise GetBufferedPromise
       * @fulfill {Array} Buffered Timeranges converted to an Array.
       */

      /**
       * Get the buffered property of the video.
       *
       * @return {GetBufferedPromise}
       */

    }, {
      key: "getBuffered",
      value: function getBuffered() {
        return this.get('buffered');
      }
      /**
       * @typedef {Object} CameraProperties
       * @prop {number} props.yaw - Number between 0 and 360.
       * @prop {number} props.pitch - Number between -90 and 90.
       * @prop {number} props.roll - Number between -180 and 180.
       * @prop {number} props.fov - The field of view in degrees.
       */

      /**
       * A promise to get the camera properties of the player.
       *
       * @promise GetCameraPromise
       * @fulfill {CameraProperties} The camera properties.
       */

      /**
       * For 360° videos get the camera properties for this player.
       *
       * @return {GetCameraPromise}
       */

    }, {
      key: "getCameraProps",
      value: function getCameraProps() {
        return this.get('cameraProps');
      }
      /**
       * A promise to set the camera properties of the player.
       *
       * @promise SetCameraPromise
       * @fulfill {Object} The camera was successfully set.
       * @reject {RangeError} The range was out of bounds.
       */

      /**
       * For 360° videos set the camera properties for this player.
       *
       * @param {CameraProperties} camera The camera properties
       * @return {SetCameraPromise}
       */

    }, {
      key: "setCameraProps",
      value: function setCameraProps(camera) {
        return this.set('cameraProps', camera);
      }
      /**
       * A representation of a chapter.
       *
       * @typedef {Object} VimeoChapter
       * @property {number} startTime The start time of the chapter.
       * @property {object} title The title of the chapter.
       * @property {number} index The place in the order of Chapters. Starts at 1.
       */

      /**
       * A promise to get chapters for the video.
       *
       * @promise GetChaptersPromise
       * @fulfill {VimeoChapter[]} The chapters for the video.
       */

      /**
       * Get an array of all the chapters for the video.
       *
       * @return {GetChaptersPromise}
       */

    }, {
      key: "getChapters",
      value: function getChapters() {
        return this.get('chapters');
      }
      /**
       * A promise to get the currently active chapter.
       *
       * @promise GetCurrentChaptersPromise
       * @fulfill {VimeoChapter|undefined} The current chapter for the video.
       */

      /**
       * Get the currently active chapter for the video.
       *
       * @return {GetCurrentChaptersPromise}
       */

    }, {
      key: "getCurrentChapter",
      value: function getCurrentChapter() {
        return this.get('currentChapter');
      }
      /**
       * A promise to get the color of the player.
       *
       * @promise GetColorPromise
       * @fulfill {string} The hex color of the player.
       */

      /**
       * Get the color for this player.
       *
       * @return {GetColorPromise}
       */

    }, {
      key: "getColor",
      value: function getColor() {
        return this.get('color');
      }
      /**
       * A promise to set the color of the player.
       *
       * @promise SetColorPromise
       * @fulfill {string} The color was successfully set.
       * @reject {TypeError} The string was not a valid hex or rgb color.
       * @reject {ContrastError} The color was set, but the contrast is
       *         outside of the acceptable range.
       * @reject {EmbedSettingsError} The owner of the player has chosen to
       *         use a specific color.
       */

      /**
       * Set the color of this player to a hex or rgb string. Setting the
       * color may fail if the owner of the video has set their embed
       * preferences to force a specific color.
       *
       * @param {string} color The hex or rgb color string to set.
       * @return {SetColorPromise}
       */

    }, {
      key: "setColor",
      value: function setColor(color) {
        return this.set('color', color);
      }
      /**
       * A representation of a cue point.
       *
       * @typedef {Object} VimeoCuePoint
       * @property {number} time The time of the cue point.
       * @property {object} data The data passed when adding the cue point.
       * @property {string} id The unique id for use with removeCuePoint.
       */

      /**
       * A promise to get the cue points of a video.
       *
       * @promise GetCuePointsPromise
       * @fulfill {VimeoCuePoint[]} The cue points added to the video.
       * @reject {UnsupportedError} Cue points are not supported with the current
       *         player or browser.
       */

      /**
       * Get an array of the cue points added to the video.
       *
       * @return {GetCuePointsPromise}
       */

    }, {
      key: "getCuePoints",
      value: function getCuePoints() {
        return this.get('cuePoints');
      }
      /**
       * A promise to get the current time of the video.
       *
       * @promise GetCurrentTimePromise
       * @fulfill {number} The current time in seconds.
       */

      /**
       * Get the current playback position in seconds.
       *
       * @return {GetCurrentTimePromise}
       */

    }, {
      key: "getCurrentTime",
      value: function getCurrentTime() {
        return this.get('currentTime');
      }
      /**
       * A promise to set the current time of the video.
       *
       * @promise SetCurrentTimePromise
       * @fulfill {number} The actual current time that was set.
       * @reject {RangeError} the time was less than 0 or greater than the
       *         video’s duration.
       */

      /**
       * Set the current playback position in seconds. If the player was
       * paused, it will remain paused. Likewise, if the player was playing,
       * it will resume playing once the video has buffered.
       *
       * You can provide an accurate time and the player will attempt to seek
       * to as close to that time as possible. The exact time will be the
       * fulfilled value of the promise.
       *
       * @param {number} currentTime
       * @return {SetCurrentTimePromise}
       */

    }, {
      key: "setCurrentTime",
      value: function setCurrentTime(currentTime) {
        return this.set('currentTime', currentTime);
      }
      /**
       * A promise to get the duration of the video.
       *
       * @promise GetDurationPromise
       * @fulfill {number} The duration in seconds.
       */

      /**
       * Get the duration of the video in seconds. It will be rounded to the
       * nearest second before playback begins, and to the nearest thousandth
       * of a second after playback begins.
       *
       * @return {GetDurationPromise}
       */

    }, {
      key: "getDuration",
      value: function getDuration() {
        return this.get('duration');
      }
      /**
       * A promise to get the ended state of the video.
       *
       * @promise GetEndedPromise
       * @fulfill {boolean} Whether or not the video has ended.
       */

      /**
       * Get the ended state of the video. The video has ended if
       * `currentTime === duration`.
       *
       * @return {GetEndedPromise}
       */

    }, {
      key: "getEnded",
      value: function getEnded() {
        return this.get('ended');
      }
      /**
       * A promise to get the loop state of the player.
       *
       * @promise GetLoopPromise
       * @fulfill {boolean} Whether or not the player is set to loop.
       */

      /**
       * Get the loop state of the player.
       *
       * @return {GetLoopPromise}
       */

    }, {
      key: "getLoop",
      value: function getLoop() {
        return this.get('loop');
      }
      /**
       * A promise to set the loop state of the player.
       *
       * @promise SetLoopPromise
       * @fulfill {boolean} The loop state that was set.
       */

      /**
       * Set the loop state of the player. When set to `true`, the player
       * will start over immediately once playback ends.
       *
       * @param {boolean} loop
       * @return {SetLoopPromise}
       */

    }, {
      key: "setLoop",
      value: function setLoop(loop) {
        return this.set('loop', loop);
      }
      /**
       * A promise to set the muted state of the player.
       *
       * @promise SetMutedPromise
       * @fulfill {boolean} The muted state that was set.
       */

      /**
       * Set the muted state of the player. When set to `true`, the player
       * volume will be muted.
       *
       * @param {boolean} muted
       * @return {SetMutedPromise}
       */

    }, {
      key: "setMuted",
      value: function setMuted(muted) {
        return this.set('muted', muted);
      }
      /**
       * A promise to get the muted state of the player.
       *
       * @promise GetMutedPromise
       * @fulfill {boolean} Whether or not the player is muted.
       */

      /**
       * Get the muted state of the player.
       *
       * @return {GetMutedPromise}
       */

    }, {
      key: "getMuted",
      value: function getMuted() {
        return this.get('muted');
      }
      /**
       * A promise to get the paused state of the player.
       *
       * @promise GetLoopPromise
       * @fulfill {boolean} Whether or not the video is paused.
       */

      /**
       * Get the paused state of the player.
       *
       * @return {GetLoopPromise}
       */

    }, {
      key: "getPaused",
      value: function getPaused() {
        return this.get('paused');
      }
      /**
       * A promise to get the playback rate of the player.
       *
       * @promise GetPlaybackRatePromise
       * @fulfill {number} The playback rate of the player on a scale from 0.5 to 2.
       */

      /**
       * Get the playback rate of the player on a scale from `0.5` to `2`.
       *
       * @return {GetPlaybackRatePromise}
       */

    }, {
      key: "getPlaybackRate",
      value: function getPlaybackRate() {
        return this.get('playbackRate');
      }
      /**
       * A promise to set the playbackrate of the player.
       *
       * @promise SetPlaybackRatePromise
       * @fulfill {number} The playback rate was set.
       * @reject {RangeError} The playback rate was less than 0.5 or greater than 2.
       */

      /**
       * Set the playback rate of the player on a scale from `0.5` to `2`. When set
       * via the API, the playback rate will not be synchronized to other
       * players or stored as the viewer's preference.
       *
       * @param {number} playbackRate
       * @return {SetPlaybackRatePromise}
       */

    }, {
      key: "setPlaybackRate",
      value: function setPlaybackRate(playbackRate) {
        return this.set('playbackRate', playbackRate);
      }
      /**
       * A promise to get the played property of the video.
       *
       * @promise GetPlayedPromise
       * @fulfill {Array} Played Timeranges converted to an Array.
       */

      /**
       * Get the played property of the video.
       *
       * @return {GetPlayedPromise}
       */

    }, {
      key: "getPlayed",
      value: function getPlayed() {
        return this.get('played');
      }
      /**
       * A promise to get the qualities available of the current video.
       *
       * @promise GetQualitiesPromise
       * @fulfill {Array} The qualities of the video.
       */

      /**
       * Get the qualities of the current video.
       *
       * @return {GetQualitiesPromise}
       */

    }, {
      key: "getQualities",
      value: function getQualities() {
        return this.get('qualities');
      }
      /**
       * A promise to get the current set quality of the video.
       *
       * @promise GetQualityPromise
       * @fulfill {string} The current set quality.
       */

      /**
       * Get the current set quality of the video.
       *
       * @return {GetQualityPromise}
       */

    }, {
      key: "getQuality",
      value: function getQuality() {
        return this.get('quality');
      }
      /**
       * A promise to set the video quality.
       *
       * @promise SetQualityPromise
       * @fulfill {number} The quality was set.
       * @reject {RangeError} The quality is not available.
       */

      /**
       * Set a video quality.
       *
       * @param {string} quality
       * @return {SetQualityPromise}
       */

    }, {
      key: "setQuality",
      value: function setQuality(quality) {
        return this.set('quality', quality);
      }
      /**
       * A promise to get the seekable property of the video.
       *
       * @promise GetSeekablePromise
       * @fulfill {Array} Seekable Timeranges converted to an Array.
       */

      /**
       * Get the seekable property of the video.
       *
       * @return {GetSeekablePromise}
       */

    }, {
      key: "getSeekable",
      value: function getSeekable() {
        return this.get('seekable');
      }
      /**
       * A promise to get the seeking property of the player.
       *
       * @promise GetSeekingPromise
       * @fulfill {boolean} Whether or not the player is currently seeking.
       */

      /**
       * Get if the player is currently seeking.
       *
       * @return {GetSeekingPromise}
       */

    }, {
      key: "getSeeking",
      value: function getSeeking() {
        return this.get('seeking');
      }
      /**
       * A promise to get the text tracks of a video.
       *
       * @promise GetTextTracksPromise
       * @fulfill {VimeoTextTrack[]} The text tracks associated with the video.
       */

      /**
       * Get an array of the text tracks that exist for the video.
       *
       * @return {GetTextTracksPromise}
       */

    }, {
      key: "getTextTracks",
      value: function getTextTracks() {
        return this.get('textTracks');
      }
      /**
       * A promise to get the embed code for the video.
       *
       * @promise GetVideoEmbedCodePromise
       * @fulfill {string} The `<iframe>` embed code for the video.
       */

      /**
       * Get the `<iframe>` embed code for the video.
       *
       * @return {GetVideoEmbedCodePromise}
       */

    }, {
      key: "getVideoEmbedCode",
      value: function getVideoEmbedCode() {
        return this.get('videoEmbedCode');
      }
      /**
       * A promise to get the id of the video.
       *
       * @promise GetVideoIdPromise
       * @fulfill {number} The id of the video.
       */

      /**
       * Get the id of the video.
       *
       * @return {GetVideoIdPromise}
       */

    }, {
      key: "getVideoId",
      value: function getVideoId() {
        return this.get('videoId');
      }
      /**
       * A promise to get the title of the video.
       *
       * @promise GetVideoTitlePromise
       * @fulfill {number} The title of the video.
       */

      /**
       * Get the title of the video.
       *
       * @return {GetVideoTitlePromise}
       */

    }, {
      key: "getVideoTitle",
      value: function getVideoTitle() {
        return this.get('videoTitle');
      }
      /**
       * A promise to get the native width of the video.
       *
       * @promise GetVideoWidthPromise
       * @fulfill {number} The native width of the video.
       */

      /**
       * Get the native width of the currently‐playing video. The width of
       * the highest‐resolution available will be used before playback begins.
       *
       * @return {GetVideoWidthPromise}
       */

    }, {
      key: "getVideoWidth",
      value: function getVideoWidth() {
        return this.get('videoWidth');
      }
      /**
       * A promise to get the native height of the video.
       *
       * @promise GetVideoHeightPromise
       * @fulfill {number} The native height of the video.
       */

      /**
       * Get the native height of the currently‐playing video. The height of
       * the highest‐resolution available will be used before playback begins.
       *
       * @return {GetVideoHeightPromise}
       */

    }, {
      key: "getVideoHeight",
      value: function getVideoHeight() {
        return this.get('videoHeight');
      }
      /**
       * A promise to get the vimeo.com url for the video.
       *
       * @promise GetVideoUrlPromise
       * @fulfill {number} The vimeo.com url for the video.
       * @reject {PrivacyError} The url isn’t available because of the video’s privacy setting.
       */

      /**
       * Get the vimeo.com url for the video.
       *
       * @return {GetVideoUrlPromise}
       */

    }, {
      key: "getVideoUrl",
      value: function getVideoUrl() {
        return this.get('videoUrl');
      }
      /**
       * A promise to get the volume level of the player.
       *
       * @promise GetVolumePromise
       * @fulfill {number} The volume level of the player on a scale from 0 to 1.
       */

      /**
       * Get the current volume level of the player on a scale from `0` to `1`.
       *
       * Most mobile devices do not support an independent volume from the
       * system volume. In those cases, this method will always return `1`.
       *
       * @return {GetVolumePromise}
       */

    }, {
      key: "getVolume",
      value: function getVolume() {
        return this.get('volume');
      }
      /**
       * A promise to set the volume level of the player.
       *
       * @promise SetVolumePromise
       * @fulfill {number} The volume was set.
       * @reject {RangeError} The volume was less than 0 or greater than 1.
       */

      /**
       * Set the volume of the player on a scale from `0` to `1`. When set
       * via the API, the volume level will not be synchronized to other
       * players or stored as the viewer’s preference.
       *
       * Most mobile devices do not support setting the volume. An error will
       * *not* be triggered in that situation.
       *
       * @param {number} volume
       * @return {SetVolumePromise}
       */

    }, {
      key: "setVolume",
      value: function setVolume(volume) {
        return this.set('volume', volume);
      }
    }]);

    return Player;
  }(); // Setup embed only if this is not a node environment


  if (!isNode) {
    screenfull = initializeScreenfull();
    initializeEmbeds();
    resizeEmbeds();
  }

  function getDefaultExportFromCjs (x) {
  	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
  }

  var dist = {exports: {}};

  var Sister;

  /**
  * @link https://github.com/gajus/sister for the canonical source repository
  * @license https://github.com/gajus/sister/blob/master/LICENSE BSD 3-Clause
  */
  Sister = function () {
      var sister = {},
          events = {};

      /**
       * @name handler
       * @function
       * @param {Object} data Event data.
       */

      /**
       * @param {String} name Event name.
       * @param {handler} handler
       * @return {listener}
       */
      sister.on = function (name, handler) {
          var listener = {name: name, handler: handler};
          events[name] = events[name] || [];
          events[name].unshift(listener);
          return listener;
      };

      /**
       * @param {listener}
       */
      sister.off = function (listener) {
          var index = events[listener.name].indexOf(listener);

          if (index !== -1) {
              events[listener.name].splice(index, 1);
          }
      };

      /**
       * @param {String} name Event name.
       * @param {Object} data Event data.
       */
      sister.trigger = function (name, data) {
          var listeners = events[name],
              i;

          if (listeners) {
              i = listeners.length;
              while (i--) {
                  listeners[i].handler(data);
              }
          }
      };

      return sister;
  };

  var sister = Sister;

  var loadYouTubeIframeApi = {exports: {}};

  var loadScript = function load (src, opts, cb) {
    var head = document.head || document.getElementsByTagName('head')[0];
    var script = document.createElement('script');

    if (typeof opts === 'function') {
      cb = opts;
      opts = {};
    }

    opts = opts || {};
    cb = cb || function() {};

    script.type = opts.type || 'text/javascript';
    script.charset = opts.charset || 'utf8';
    script.async = 'async' in opts ? !!opts.async : true;
    script.src = src;

    if (opts.attrs) {
      setAttributes(script, opts.attrs);
    }

    if (opts.text) {
      script.text = '' + opts.text;
    }

    var onend = 'onload' in script ? stdOnEnd : ieOnEnd;
    onend(script, cb);

    // some good legacy browsers (firefox) fail the 'in' detection above
    // so as a fallback we always set onload
    // old IE will ignore this and new IE will set onload
    if (!script.onload) {
      stdOnEnd(script, cb);
    }

    head.appendChild(script);
  };

  function setAttributes(script, attrs) {
    for (var attr in attrs) {
      script.setAttribute(attr, attrs[attr]);
    }
  }

  function stdOnEnd (script, cb) {
    script.onload = function () {
      this.onerror = this.onload = null;
      cb(null, script);
    };
    script.onerror = function () {
      // this.onload = null here is necessary
      // because even IE9 works not like others
      this.onerror = this.onload = null;
      cb(new Error('Failed to load ' + this.src), script);
    };
  }

  function ieOnEnd (script, cb) {
    script.onreadystatechange = function () {
      if (this.readyState != 'complete' && this.readyState != 'loaded') return
      this.onreadystatechange = null;
      cb(null, script); // there is no way to catch loading errors in IE8
    };
  }

  (function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _loadScript = loadScript;

  var _loadScript2 = _interopRequireDefault(_loadScript);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  exports.default = function (emitter) {
    /**
     * A promise that is resolved when window.onYouTubeIframeAPIReady is called.
     * The promise is resolved with a reference to window.YT object.
     */
    var iframeAPIReady = new Promise(function (resolve) {
      if (window.YT && window.YT.Player && window.YT.Player instanceof Function) {
        resolve(window.YT);

        return;
      } else {
        var protocol = window.location.protocol === 'http:' ? 'http:' : 'https:';

        (0, _loadScript2.default)(protocol + '//www.youtube.com/iframe_api', function (error) {
          if (error) {
            emitter.trigger('error', error);
          }
        });
      }

      var previous = window.onYouTubeIframeAPIReady;

      // The API will call this function when page has finished downloading
      // the JavaScript for the player API.
      window.onYouTubeIframeAPIReady = function () {
        if (previous) {
          previous();
        }

        resolve(window.YT);
      };
    });

    return iframeAPIReady;
  };

  module.exports = exports['default'];
  }(loadYouTubeIframeApi, loadYouTubeIframeApi.exports));

  var YouTubePlayer$1 = {exports: {}};

  // shim for using process in browser
  // based off https://github.com/defunctzombie/node-process/blob/master/browser.js

  function defaultSetTimout() {
      throw new Error('setTimeout has not been defined');
  }
  function defaultClearTimeout () {
      throw new Error('clearTimeout has not been defined');
  }
  var cachedSetTimeout = defaultSetTimout;
  var cachedClearTimeout = defaultClearTimeout;
  if (typeof global$1.setTimeout === 'function') {
      cachedSetTimeout = setTimeout;
  }
  if (typeof global$1.clearTimeout === 'function') {
      cachedClearTimeout = clearTimeout;
  }

  function runTimeout(fun) {
      if (cachedSetTimeout === setTimeout) {
          //normal enviroments in sane situations
          return setTimeout(fun, 0);
      }
      // if setTimeout wasn't available but was latter defined
      if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
          cachedSetTimeout = setTimeout;
          return setTimeout(fun, 0);
      }
      try {
          // when when somebody has screwed with setTimeout but no I.E. maddness
          return cachedSetTimeout(fun, 0);
      } catch(e){
          try {
              // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
              return cachedSetTimeout.call(null, fun, 0);
          } catch(e){
              // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
              return cachedSetTimeout.call(this, fun, 0);
          }
      }


  }
  function runClearTimeout(marker) {
      if (cachedClearTimeout === clearTimeout) {
          //normal enviroments in sane situations
          return clearTimeout(marker);
      }
      // if clearTimeout wasn't available but was latter defined
      if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
          cachedClearTimeout = clearTimeout;
          return clearTimeout(marker);
      }
      try {
          // when when somebody has screwed with setTimeout but no I.E. maddness
          return cachedClearTimeout(marker);
      } catch (e){
          try {
              // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
              return cachedClearTimeout.call(null, marker);
          } catch (e){
              // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
              // Some versions of I.E. have different rules for clearTimeout vs setTimeout
              return cachedClearTimeout.call(this, marker);
          }
      }



  }
  var queue = [];
  var draining = false;
  var currentQueue;
  var queueIndex = -1;

  function cleanUpNextTick() {
      if (!draining || !currentQueue) {
          return;
      }
      draining = false;
      if (currentQueue.length) {
          queue = currentQueue.concat(queue);
      } else {
          queueIndex = -1;
      }
      if (queue.length) {
          drainQueue();
      }
  }

  function drainQueue() {
      if (draining) {
          return;
      }
      var timeout = runTimeout(cleanUpNextTick);
      draining = true;

      var len = queue.length;
      while(len) {
          currentQueue = queue;
          queue = [];
          while (++queueIndex < len) {
              if (currentQueue) {
                  currentQueue[queueIndex].run();
              }
          }
          queueIndex = -1;
          len = queue.length;
      }
      currentQueue = null;
      draining = false;
      runClearTimeout(timeout);
  }
  function nextTick(fun) {
      var args = new Array(arguments.length - 1);
      if (arguments.length > 1) {
          for (var i = 1; i < arguments.length; i++) {
              args[i - 1] = arguments[i];
          }
      }
      queue.push(new Item(fun, args));
      if (queue.length === 1 && !draining) {
          runTimeout(drainQueue);
      }
  }
  // v8 likes predictible objects
  function Item(fun, array) {
      this.fun = fun;
      this.array = array;
  }
  Item.prototype.run = function () {
      this.fun.apply(null, this.array);
  };
  var title = 'browser';
  var platform = 'browser';
  var browser$1 = true;
  var env = {};
  var argv = [];
  var version = ''; // empty string to avoid regexp issues
  var versions = {};
  var release = {};
  var config = {};

  function noop() {}

  var on = noop;
  var addListener = noop;
  var once = noop;
  var off = noop;
  var removeListener = noop;
  var removeAllListeners = noop;
  var emit = noop;

  function binding(name) {
      throw new Error('process.binding is not supported');
  }

  function cwd () { return '/' }
  function chdir (dir) {
      throw new Error('process.chdir is not supported');
  }function umask() { return 0; }

  // from https://github.com/kumavis/browser-process-hrtime/blob/master/index.js
  var performance = global$1.performance || {};
  var performanceNow =
    performance.now        ||
    performance.mozNow     ||
    performance.msNow      ||
    performance.oNow       ||
    performance.webkitNow  ||
    function(){ return (new Date()).getTime() };

  // generate timestamp or delta
  // see http://nodejs.org/api/process.html#process_process_hrtime
  function hrtime(previousTimestamp){
    var clocktime = performanceNow.call(performance)*1e-3;
    var seconds = Math.floor(clocktime);
    var nanoseconds = Math.floor((clocktime%1)*1e9);
    if (previousTimestamp) {
      seconds = seconds - previousTimestamp[0];
      nanoseconds = nanoseconds - previousTimestamp[1];
      if (nanoseconds<0) {
        seconds--;
        nanoseconds += 1e9;
      }
    }
    return [seconds,nanoseconds]
  }

  var startTime = new Date();
  function uptime() {
    var currentTime = new Date();
    var dif = currentTime - startTime;
    return dif / 1000;
  }

  var browser$1$1 = {
    nextTick: nextTick,
    title: title,
    browser: browser$1,
    env: env,
    argv: argv,
    version: version,
    versions: versions,
    on: on,
    addListener: addListener,
    once: once,
    off: off,
    removeListener: removeListener,
    removeAllListeners: removeAllListeners,
    emit: emit,
    binding: binding,
    cwd: cwd,
    chdir: chdir,
    umask: umask,
    hrtime: hrtime,
    platform: platform,
    release: release,
    config: config,
    uptime: uptime
  };

  var browser = {exports: {}};

  var debug = {exports: {}};

  /**
   * Helpers.
   */

  var s = 1000;
  var m = s * 60;
  var h = m * 60;
  var d = h * 24;
  var y = d * 365.25;

  /**
   * Parse or format the given `val`.
   *
   * Options:
   *
   *  - `long` verbose formatting [false]
   *
   * @param {String|Number} val
   * @param {Object} [options]
   * @throws {Error} throw an error if val is not a non-empty string or a number
   * @return {String|Number}
   * @api public
   */

  var ms = function(val, options) {
    options = options || {};
    var type = typeof val;
    if (type === 'string' && val.length > 0) {
      return parse(val);
    } else if (type === 'number' && isNaN(val) === false) {
      return options.long ? fmtLong(val) : fmtShort(val);
    }
    throw new Error(
      'val is not a non-empty string or a valid number. val=' +
        JSON.stringify(val)
    );
  };

  /**
   * Parse the given `str` and return milliseconds.
   *
   * @param {String} str
   * @return {Number}
   * @api private
   */

  function parse(str) {
    str = String(str);
    if (str.length > 100) {
      return;
    }
    var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
      str
    );
    if (!match) {
      return;
    }
    var n = parseFloat(match[1]);
    var type = (match[2] || 'ms').toLowerCase();
    switch (type) {
      case 'years':
      case 'year':
      case 'yrs':
      case 'yr':
      case 'y':
        return n * y;
      case 'days':
      case 'day':
      case 'd':
        return n * d;
      case 'hours':
      case 'hour':
      case 'hrs':
      case 'hr':
      case 'h':
        return n * h;
      case 'minutes':
      case 'minute':
      case 'mins':
      case 'min':
      case 'm':
        return n * m;
      case 'seconds':
      case 'second':
      case 'secs':
      case 'sec':
      case 's':
        return n * s;
      case 'milliseconds':
      case 'millisecond':
      case 'msecs':
      case 'msec':
      case 'ms':
        return n;
      default:
        return undefined;
    }
  }

  /**
   * Short format for `ms`.
   *
   * @param {Number} ms
   * @return {String}
   * @api private
   */

  function fmtShort(ms) {
    if (ms >= d) {
      return Math.round(ms / d) + 'd';
    }
    if (ms >= h) {
      return Math.round(ms / h) + 'h';
    }
    if (ms >= m) {
      return Math.round(ms / m) + 'm';
    }
    if (ms >= s) {
      return Math.round(ms / s) + 's';
    }
    return ms + 'ms';
  }

  /**
   * Long format for `ms`.
   *
   * @param {Number} ms
   * @return {String}
   * @api private
   */

  function fmtLong(ms) {
    return plural(ms, d, 'day') ||
      plural(ms, h, 'hour') ||
      plural(ms, m, 'minute') ||
      plural(ms, s, 'second') ||
      ms + ' ms';
  }

  /**
   * Pluralization helper.
   */

  function plural(ms, n, name) {
    if (ms < n) {
      return;
    }
    if (ms < n * 1.5) {
      return Math.floor(ms / n) + ' ' + name;
    }
    return Math.ceil(ms / n) + ' ' + name + 's';
  }

  (function (module, exports) {
  /**
   * This is the common logic for both the Node.js and web browser
   * implementations of `debug()`.
   *
   * Expose `debug()` as the module.
   */

  exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
  exports.coerce = coerce;
  exports.disable = disable;
  exports.enable = enable;
  exports.enabled = enabled;
  exports.humanize = ms;

  /**
   * The currently active debug mode names, and names to skip.
   */

  exports.names = [];
  exports.skips = [];

  /**
   * Map of special "%n" handling functions, for the debug "format" argument.
   *
   * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
   */

  exports.formatters = {};

  /**
   * Previous log timestamp.
   */

  var prevTime;

  /**
   * Select a color.
   * @param {String} namespace
   * @return {Number}
   * @api private
   */

  function selectColor(namespace) {
    var hash = 0, i;

    for (i in namespace) {
      hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
      hash |= 0; // Convert to 32bit integer
    }

    return exports.colors[Math.abs(hash) % exports.colors.length];
  }

  /**
   * Create a debugger with the given `namespace`.
   *
   * @param {String} namespace
   * @return {Function}
   * @api public
   */

  function createDebug(namespace) {

    function debug() {
      // disabled?
      if (!debug.enabled) return;

      var self = debug;

      // set `diff` timestamp
      var curr = +new Date();
      var ms = curr - (prevTime || curr);
      self.diff = ms;
      self.prev = prevTime;
      self.curr = curr;
      prevTime = curr;

      // turn the `arguments` into a proper Array
      var args = new Array(arguments.length);
      for (var i = 0; i < args.length; i++) {
        args[i] = arguments[i];
      }

      args[0] = exports.coerce(args[0]);

      if ('string' !== typeof args[0]) {
        // anything else let's inspect with %O
        args.unshift('%O');
      }

      // apply any `formatters` transformations
      var index = 0;
      args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
        // if we encounter an escaped % then don't increase the array index
        if (match === '%%') return match;
        index++;
        var formatter = exports.formatters[format];
        if ('function' === typeof formatter) {
          var val = args[index];
          match = formatter.call(self, val);

          // now we need to remove `args[index]` since it's inlined in the `format`
          args.splice(index, 1);
          index--;
        }
        return match;
      });

      // apply env-specific formatting (colors, etc.)
      exports.formatArgs.call(self, args);

      var logFn = debug.log || exports.log || console.log.bind(console);
      logFn.apply(self, args);
    }

    debug.namespace = namespace;
    debug.enabled = exports.enabled(namespace);
    debug.useColors = exports.useColors();
    debug.color = selectColor(namespace);

    // env-specific initialization logic for debug instances
    if ('function' === typeof exports.init) {
      exports.init(debug);
    }

    return debug;
  }

  /**
   * Enables a debug mode by namespaces. This can include modes
   * separated by a colon and wildcards.
   *
   * @param {String} namespaces
   * @api public
   */

  function enable(namespaces) {
    exports.save(namespaces);

    exports.names = [];
    exports.skips = [];

    var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
    var len = split.length;

    for (var i = 0; i < len; i++) {
      if (!split[i]) continue; // ignore empty strings
      namespaces = split[i].replace(/\*/g, '.*?');
      if (namespaces[0] === '-') {
        exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
      } else {
        exports.names.push(new RegExp('^' + namespaces + '$'));
      }
    }
  }

  /**
   * Disable debug output.
   *
   * @api public
   */

  function disable() {
    exports.enable('');
  }

  /**
   * Returns true if the given mode name is enabled, false otherwise.
   *
   * @param {String} name
   * @return {Boolean}
   * @api public
   */

  function enabled(name) {
    var i, len;
    for (i = 0, len = exports.skips.length; i < len; i++) {
      if (exports.skips[i].test(name)) {
        return false;
      }
    }
    for (i = 0, len = exports.names.length; i < len; i++) {
      if (exports.names[i].test(name)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Coerce `val`.
   *
   * @param {Mixed} val
   * @return {Mixed}
   * @api private
   */

  function coerce(val) {
    if (val instanceof Error) return val.stack || val.message;
    return val;
  }
  }(debug, debug.exports));

  (function (module, exports) {
  exports = module.exports = debug.exports;
  exports.log = log;
  exports.formatArgs = formatArgs;
  exports.save = save;
  exports.load = load;
  exports.useColors = useColors;
  exports.storage = 'undefined' != typeof chrome
                 && 'undefined' != typeof chrome.storage
                    ? chrome.storage.local
                    : localstorage();

  /**
   * Colors.
   */

  exports.colors = [
    'lightseagreen',
    'forestgreen',
    'goldenrod',
    'dodgerblue',
    'darkorchid',
    'crimson'
  ];

  /**
   * Currently only WebKit-based Web Inspectors, Firefox >= v31,
   * and the Firebug extension (any Firefox version) are known
   * to support "%c" CSS customizations.
   *
   * TODO: add a `localStorage` variable to explicitly enable/disable colors
   */

  function useColors() {
    // NB: In an Electron preload script, document will be defined but not fully
    // initialized. Since we know we're in Chrome, we'll just detect this case
    // explicitly
    if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
      return true;
    }

    // is webkit? http://stackoverflow.com/a/16459606/376773
    // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
    return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
      // is firebug? http://stackoverflow.com/a/398120/376773
      (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
      // is firefox >= v31?
      // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
      (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
      // double check webkit in userAgent just in case we are in a worker
      (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
  }

  /**
   * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
   */

  exports.formatters.j = function(v) {
    try {
      return JSON.stringify(v);
    } catch (err) {
      return '[UnexpectedJSONParseError]: ' + err.message;
    }
  };


  /**
   * Colorize log arguments if enabled.
   *
   * @api public
   */

  function formatArgs(args) {
    var useColors = this.useColors;

    args[0] = (useColors ? '%c' : '')
      + this.namespace
      + (useColors ? ' %c' : ' ')
      + args[0]
      + (useColors ? '%c ' : ' ')
      + '+' + exports.humanize(this.diff);

    if (!useColors) return;

    var c = 'color: ' + this.color;
    args.splice(1, 0, c, 'color: inherit');

    // the final "%c" is somewhat tricky, because there could be other
    // arguments passed either before or after the %c, so we need to
    // figure out the correct index to insert the CSS into
    var index = 0;
    var lastC = 0;
    args[0].replace(/%[a-zA-Z%]/g, function(match) {
      if ('%%' === match) return;
      index++;
      if ('%c' === match) {
        // we only are interested in the *last* %c
        // (the user may have provided their own)
        lastC = index;
      }
    });

    args.splice(lastC, 0, c);
  }

  /**
   * Invokes `console.log()` when available.
   * No-op when `console.log` is not a "function".
   *
   * @api public
   */

  function log() {
    // this hackery is required for IE8/9, where
    // the `console.log` function doesn't have 'apply'
    return 'object' === typeof console
      && console.log
      && Function.prototype.apply.call(console.log, console, arguments);
  }

  /**
   * Save `namespaces`.
   *
   * @param {String} namespaces
   * @api private
   */

  function save(namespaces) {
    try {
      if (null == namespaces) {
        exports.storage.removeItem('debug');
      } else {
        exports.storage.debug = namespaces;
      }
    } catch(e) {}
  }

  /**
   * Load `namespaces`.
   *
   * @return {String} returns the previously persisted debug modes
   * @api private
   */

  function load() {
    var r;
    try {
      r = exports.storage.debug;
    } catch(e) {}

    // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
    if (!r && typeof browser$1$1 !== 'undefined' && 'env' in browser$1$1) {
      r = browser$1$1.env.DEBUG;
    }

    return r;
  }

  /**
   * Enable namespaces listed in `localStorage.debug` initially.
   */

  exports.enable(load());

  /**
   * Localstorage attempts to return the localstorage.
   *
   * This is necessary because safari throws
   * when a user disables cookies/localstorage
   * and you attempt to access it.
   *
   * @return {LocalStorage}
   * @api private
   */

  function localstorage() {
    try {
      return window.localStorage;
    } catch (e) {}
  }
  }(browser, browser.exports));

  var functionNames = {exports: {}};

  (function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });


  /**
   * @see https://developers.google.com/youtube/iframe_api_reference#Functions
   */
  exports.default = ['cueVideoById', 'loadVideoById', 'cueVideoByUrl', 'loadVideoByUrl', 'playVideo', 'pauseVideo', 'stopVideo', 'getVideoLoadedFraction', 'cuePlaylist', 'loadPlaylist', 'nextVideo', 'previousVideo', 'playVideoAt', 'setShuffle', 'setLoop', 'getPlaylist', 'getPlaylistIndex', 'setOption', 'mute', 'unMute', 'isMuted', 'setVolume', 'getVolume', 'seekTo', 'getPlayerState', 'getPlaybackRate', 'setPlaybackRate', 'getAvailablePlaybackRates', 'getPlaybackQuality', 'setPlaybackQuality', 'getAvailableQualityLevels', 'getCurrentTime', 'getDuration', 'removeEventListener', 'getVideoUrl', 'getVideoEmbedCode', 'getOptions', 'getOption', 'addEventListener', 'destroy', 'setSize', 'getIframe'];
  module.exports = exports['default'];
  }(functionNames, functionNames.exports));

  var eventNames = {exports: {}};

  (function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });


  /**
   * @see https://developers.google.com/youtube/iframe_api_reference#Events
   * `volumeChange` is not officially supported but seems to work
   * it emits an object: `{volume: 82.6923076923077, muted: false}`
   */
  exports.default = ['ready', 'stateChange', 'playbackQualityChange', 'playbackRateChange', 'error', 'apiChange', 'volumeChange'];
  module.exports = exports['default'];
  }(eventNames, eventNames.exports));

  var FunctionStateMap = {exports: {}};

  var PlayerStates = {exports: {}};

  (function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = {
    BUFFERING: 3,
    ENDED: 0,
    PAUSED: 2,
    PLAYING: 1,
    UNSTARTED: -1,
    VIDEO_CUED: 5
  };
  module.exports = exports["default"];
  }(PlayerStates, PlayerStates.exports));

  (function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _PlayerStates = PlayerStates.exports;

  var _PlayerStates2 = _interopRequireDefault(_PlayerStates);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  exports.default = {
    pauseVideo: {
      acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PAUSED],
      stateChangeRequired: false
    },
    playVideo: {
      acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PLAYING],
      stateChangeRequired: false
    },
    seekTo: {
      acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PLAYING, _PlayerStates2.default.PAUSED],
      stateChangeRequired: true,

      // TRICKY: `seekTo` may not cause a state change if no buffering is
      // required.
      timeout: 3000
    }
  };
  module.exports = exports['default'];
  }(FunctionStateMap, FunctionStateMap.exports));

  (function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _debug = browser.exports;

  var _debug2 = _interopRequireDefault(_debug);

  var _functionNames = functionNames.exports;

  var _functionNames2 = _interopRequireDefault(_functionNames);

  var _eventNames = eventNames.exports;

  var _eventNames2 = _interopRequireDefault(_eventNames);

  var _FunctionStateMap = FunctionStateMap.exports;

  var _FunctionStateMap2 = _interopRequireDefault(_FunctionStateMap);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  /* eslint-disable promise/prefer-await-to-then */

  var debug = (0, _debug2.default)('youtube-player');

  var YouTubePlayer = {};

  /**
   * Construct an object that defines an event handler for all of the YouTube
   * player events. Proxy captured events through an event emitter.
   *
   * @todo Capture event parameters.
   * @see https://developers.google.com/youtube/iframe_api_reference#Events
   */
  YouTubePlayer.proxyEvents = function (emitter) {
    var events = {};

    var _loop = function _loop(eventName) {
      var onEventName = 'on' + eventName.slice(0, 1).toUpperCase() + eventName.slice(1);

      events[onEventName] = function (event) {
        debug('event "%s"', onEventName, event);

        emitter.trigger(eventName, event);
      };
    };

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = _eventNames2.default[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var eventName = _step.value;

        _loop(eventName);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return events;
  };

  /**
   * Delays player API method execution until player state is ready.
   *
   * @todo Proxy all of the methods using Object.keys.
   * @todo See TRICKY below.
   * @param playerAPIReady Promise that resolves when player is ready.
   * @param strictState A flag designating whether or not to wait for
   * an acceptable state when calling supported functions.
   * @returns {Object}
   */
  YouTubePlayer.promisifyPlayer = function (playerAPIReady) {
    var strictState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var functions = {};

    var _loop2 = function _loop2(functionName) {
      if (strictState && _FunctionStateMap2.default[functionName]) {
        functions[functionName] = function () {
          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return playerAPIReady.then(function (player) {
            var stateInfo = _FunctionStateMap2.default[functionName];
            var playerState = player.getPlayerState();

            // eslint-disable-next-line no-warning-comments
            // TODO: Just spread the args into the function once Babel is fixed:
            // https://github.com/babel/babel/issues/4270
            //
            // eslint-disable-next-line prefer-spread
            var value = player[functionName].apply(player, args);

            // TRICKY: For functions like `seekTo`, a change in state must be
            // triggered given that the resulting state could match the initial
            // state.
            if (stateInfo.stateChangeRequired ||

            // eslint-disable-next-line no-extra-parens
            Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.indexOf(playerState) === -1) {
              return new Promise(function (resolve) {
                var onPlayerStateChange = function onPlayerStateChange() {
                  var playerStateAfterChange = player.getPlayerState();

                  var timeout = void 0;

                  if (typeof stateInfo.timeout === 'number') {
                    timeout = setTimeout(function () {
                      player.removeEventListener('onStateChange', onPlayerStateChange);

                      resolve();
                    }, stateInfo.timeout);
                  }

                  if (Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.indexOf(playerStateAfterChange) !== -1) {
                    player.removeEventListener('onStateChange', onPlayerStateChange);

                    clearTimeout(timeout);

                    resolve();
                  }
                };

                player.addEventListener('onStateChange', onPlayerStateChange);
              }).then(function () {
                return value;
              });
            }

            return value;
          });
        };
      } else {
        functions[functionName] = function () {
          for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          }

          return playerAPIReady.then(function (player) {
            // eslint-disable-next-line no-warning-comments
            // TODO: Just spread the args into the function once Babel is fixed:
            // https://github.com/babel/babel/issues/4270
            //
            // eslint-disable-next-line prefer-spread
            return player[functionName].apply(player, args);
          });
        };
      }
    };

    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = _functionNames2.default[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var functionName = _step2.value;

        _loop2(functionName);
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    return functions;
  };

  exports.default = YouTubePlayer;
  module.exports = exports['default'];
  }(YouTubePlayer$1, YouTubePlayer$1.exports));

  (function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

  var _sister = sister;

  var _sister2 = _interopRequireDefault(_sister);

  var _loadYouTubeIframeApi = loadYouTubeIframeApi.exports;

  var _loadYouTubeIframeApi2 = _interopRequireDefault(_loadYouTubeIframeApi);

  var _YouTubePlayer = YouTubePlayer$1.exports;

  var _YouTubePlayer2 = _interopRequireDefault(_YouTubePlayer);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  /**
   * @typedef YT.Player
   * @see https://developers.google.com/youtube/iframe_api_reference
   * */

  /**
   * @see https://developers.google.com/youtube/iframe_api_reference#Loading_a_Video_Player
   */
  var youtubeIframeAPI = void 0;

  /**
   * A factory function used to produce an instance of YT.Player and queue function calls and proxy events of the resulting object.
   *
   * @param maybeElementId Either An existing YT.Player instance,
   * the DOM element or the id of the HTML element where the API will insert an <iframe>.
   * @param options See `options` (Ignored when using an existing YT.Player instance).
   * @param strictState A flag designating whether or not to wait for
   * an acceptable state when calling supported functions. Default: `false`.
   * See `FunctionStateMap.js` for supported functions and acceptable states.
   */

  exports.default = function (maybeElementId) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var strictState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var emitter = (0, _sister2.default)();

    if (!youtubeIframeAPI) {
      youtubeIframeAPI = (0, _loadYouTubeIframeApi2.default)(emitter);
    }

    if (options.events) {
      throw new Error('Event handlers cannot be overwritten.');
    }

    if (typeof maybeElementId === 'string' && !document.getElementById(maybeElementId)) {
      throw new Error('Element "' + maybeElementId + '" does not exist.');
    }

    options.events = _YouTubePlayer2.default.proxyEvents(emitter);

    var playerAPIReady = new Promise(function (resolve) {
      if ((typeof maybeElementId === 'undefined' ? 'undefined' : _typeof(maybeElementId)) === 'object' && maybeElementId.playVideo instanceof Function) {
        var player = maybeElementId;

        resolve(player);
      } else {
        // asume maybeElementId can be rendered inside
        // eslint-disable-next-line promise/catch-or-return
        youtubeIframeAPI.then(function (YT) {
          // eslint-disable-line promise/prefer-await-to-then
          var player = new YT.Player(maybeElementId, options);

          emitter.on('ready', function () {
            resolve(player);
          });

          return null;
        });
      }
    });

    var playerApi = _YouTubePlayer2.default.promisifyPlayer(playerAPIReady, strictState);

    playerApi.on = emitter.on;
    playerApi.off = emitter.off;

    return playerApi;
  };

  module.exports = exports['default'];
  }(dist, dist.exports));

  var YouTubePlayer = /*@__PURE__*/getDefaultExportFromCjs(dist.exports);

  var PdpImageCarousel = /*#__PURE__*/function () {
    function PdpImageCarousel() {
      _classCallCheck$1(this, PdpImageCarousel);

      this.init();
    }

    _createClass$1(PdpImageCarousel, [{
      key: "init",
      value: function init() {
        this.els();
        this.settings();
        this.events();
      }
    }, {
      key: "els",
      value: function els() {
        // Image Carousel
        this.$carouselContainer = document.querySelector('[data-product-media]');
        this.$imageWidth = this.$carouselContainer ? this.$carouselContainer.clientWidth : 750; // sane default

        this.$imageCarousel = document.querySelector('[data-product-images]');
        this.$imageNavCarousel = document.querySelector('[data-variant-thumbs]');
        this.$selectedThumb = document.querySelector('[data-index="0"]'); // Zoom

        this.$zoom = document.querySelector('[data-product-images]');
        this.$zoomModal = document.querySelector('[data-zoom-container="image"]');
        this.$zoomClose = document.querySelector('[data-zoom-close]');
        this.$zoomList = this.$zoomModal.querySelector('ul'); // Video

        this.$video = document.querySelector('[data-product-video]');
        this.$videoModal = document.querySelector('[data-zoom-container="video"]');
        this.$videoClose = document.querySelector('[data-video-close]');
      }
    }, {
      key: "settings",
      value: function settings() {
        // Image Carousel
        this.flickityBreakpoint = '(max-width: 1199px)';
        this.hasCarousel = this.$imageCarousel !== null; // Zoom

        this.zoomIndex = 0;
        this.zoomIndexOld = 0;
      }
    }, {
      key: "events",
      value: function events() {
        this.onVariantChange();
        this.videoModal();
        this.zoomModal();
        this.thumbClick();
      }
    }, {
      key: "thumbClick",
      value: function thumbClick() {
        var _this = this;

        this.$imageNavCarousel.addEventListener('click', function (e) {
          if (e.target.closest('[data-variant-thumbs]')) {
            var _e$target$closest$que;

            var index = Number(e.target.dataset.index); // FIXME magic number due to the way thumbnail containers sometimes don't have margin to measure (i.e. video thumb)

            var margin = 4;
            var imageHeight = e.target.clientHeight + margin; // back off half an image so we can still see when something is above

            _this.$imageNavCarousel.scrollTo({
              top: index * imageHeight - imageHeight / 2,
              behavior: 'smooth'
            }); // clear and reset active state on thumbs


            (_e$target$closest$que = e.target.closest('[data-variant-thumbs]').querySelector('.active')) === null || _e$target$closest$que === void 0 ? void 0 : _e$target$closest$que.classList.remove('active');
            e.target.classList.add('active'); // scroll to main image matching this index
            // index + 1 to account for badge node, first child of main carousel

            var imageWidth = _this.$imageCarousel.children[1].clientWidth;

            _this.$imageCarousel.scrollTo({
              left: index * imageWidth,
              behavior: 'smooth'
            }); //this.$imageCarousel.children[index+1].scrollIntoView({behavior: 'smooth', inline: 'center'})

          }
        });
      }
    }, {
      key: "onVariantChange",
      value: function onVariantChange() {
        var _this2 = this;

        window.eventBus.sub('variant:changed', function (colorHandle) {
          _this2.updateThumbsImages(colorHandle);

          _this2.updateMainImages(colorHandle);

          var zoomList = document.querySelector('[data-zoom-list]');

          if (zoomList) {
            zoomList.innerHTML = '';
          }

          setTimeout(function () {
            var zoomList = document.querySelector('[data-zoom-list]');
            document.querySelectorAll("[data-zoom-bench] [data-zoom-bench-image=\"".concat(colorHandle, "\"], [data-zoom-bench] [data-zoom-bench-image=\"all\"]")).forEach(function (image, index) {
              var img = image.cloneNode(true);

              if (zoomList) {
                zoomList.appendChild(img);
              }
            });
            document.querySelectorAll('[data-zoom-list] li img').forEach(function (image, index) {
              image.setAttribute('data-index', index);
            });
            document.querySelectorAll('[data-product-images] [data-product-zoom]').forEach(function (image, index) {
              image.setAttribute('data-zoom-index', index);
            });
          }, 10);
        });
      }
    }, {
      key: "updateMainImages",
      value: function updateMainImages(ev) {
        var _this$$imageCarousel$,
            _this3 = this;

        var colorHandle = ev.detail;
        var badgeNode = (_this$$imageCarousel$ = this.$imageCarousel.querySelector('[data-carousel-badge]')) === null || _this$$imageCarousel$ === void 0 ? void 0 : _this$$imageCarousel$.cloneNode(true);
        var colorImages = Array.from(document.querySelectorAll("[data-product-images-bench] [data-variant=\"".concat(colorHandle, "\"]")));
        var videoElement = document.querySelector('[data-product-images] .product__image-container--video');
        var allImages = Array.from(document.querySelectorAll('[data-product-images-bench] [data-variant="all"]'));
        this.$imageCarousel.innerHTML = '';

        if (badgeNode) {
          this.$imageCarousel.append(badgeNode);
        }

        [].concat(_toConsumableArray(colorImages.splice(0, 1)), [videoElement], _toConsumableArray(colorImages), _toConsumableArray(allImages)).forEach(function (image, index) {
          if (index === 1 && videoElement) {
            _this3.$imageCarousel.append(videoElement);
          } else {
            if (image) _this3.$imageCarousel.append(image.cloneNode(true));
          }
        });
      }
    }, {
      key: "updateThumbsImages",
      value: function updateThumbsImages(ev) {
        var _this$$imageCarousel$2,
            _this4 = this;

        var colorHandle = ev.detail;
        var currentIndex = ((_this$$imageCarousel$2 = this.$imageCarousel.querySelector('.active')) === null || _this$$imageCarousel$2 === void 0 ? void 0 : _this$$imageCarousel$2.dataset.index) || -1; // skip if no active image

        var thumbs = Array.from(document.querySelectorAll("[data-product-thumbs-bench] [data-variant-thumb-bench=\"".concat(colorHandle, "\"]")));
        var videoThumb = document.querySelector('[data-product-thumbs-bench] [data-variant-thumb-bench="video"]');
        var allThumbs = Array.from(document.querySelectorAll('[data-product-thumbs-bench] [data-variant-thumb-bench="all"]'));
        this.$imageNavCarousel.innerHTML = '';
        [].concat(_toConsumableArray(thumbs.splice(0, 1)), [videoThumb], _toConsumableArray(thumbs), _toConsumableArray(allThumbs)).forEach(function (thumb, index) {
          if (thumb) {
            var node = thumb.cloneNode(true);
            node.querySelector('img').dataset.index = index;

            if (index === currentIndex) {
              node.querySelector('img').classList.add('active');
            }

            _this4.$imageNavCarousel.append(node);
          }
        });
      }
    }, {
      key: "videoModal",
      value: function videoModal() {
        var _this5 = this;

        this.$youtubeIframe = document.querySelector('[data-zoom-container="video"] iframe[src*="youtube"]');
        this.$vimeoIframe = document.querySelector('[data-zoom-container="video"] iframe[src*="vimeo"]');

        if (this.$vimeoIframe) {
          this.vimeoPlayer = new Player(this.$vimeoIframe);
        }

        if (this.$youtubeIframe) {
          this.youtubePlayer = YouTubePlayer('videoIframe');
        } // Open Modal


        if (this.$video) {
          this.$video.addEventListener('click', function (e) {
            e.preventDefault();

            if (window.matchMedia(_this5.flickityBreakpoint).matches) {
              if (typeof _this5.flickityCarousel === 'undefined') {
                _this5.videoOpen(e);
              }
            } else {
              _this5.videoOpen(e);
            }
          });
        }

        if (this.flickityCarousel) {
          this.flickityCarousel.on('staticClick', function (e) {
            if (e.target.closest('a') && e.target.closest('a').hasAttribute('data-product-video')) {
              _this5.videoOpen(e);
            }
          });
        } // Close Modal


        if (this.$videoClose) {
          this.$videoClose.addEventListener('click', function () {
            _this5.videoClose();
          });
        } // Close with esc key


        document.addEventListener('keyup', function (e) {
          if (e.key === 'Escape') {
            _this5.videoClose();
          }
        });
      }
    }, {
      key: "videoOpen",
      value: function videoOpen(e) {
        document.body.style.overflow = 'hidden';
        document.body.classList.add('zoom--active');

        if (this.$videoModal) {
          this.$videoModal.addClass('active');
        }

        if (this.$vimeoIframe) {
          this.vimeoPlayer.play();
        }

        if (this.$youtubeIframe) {
          this.youtubePlayer.playVideo();
        }
      }
    }, {
      key: "videoClose",
      value: function videoClose() {
        document.body.removeClass('zoom--active');
        this.$videoModal.removeClass('active');
        document.body.style.overflow = 'auto';

        if (this.$vimeoIframe) {
          this.vimeoPlayer.pause();
        }

        if (this.$youtubeIframe) {
          this.youtubePlayer.pauseVideo();
        }
      }
    }, {
      key: "zoomOpen",
      value: function zoomOpen(e) {
        var zoomBreakpoint = '0px';

        if (window.matchMedia("(min-width: ".concat(zoomBreakpoint, ")")).matches) {
          this.$zoomList.replaceChildren([]);
          this.$zoomList.appendChild(e.target.cloneNode(true));
          document.body.classList.add('zoom--active');
          document.querySelector('body').style.overflow = 'hidden';
          this.$zoomModal.classList.add('active');
          this.$zoomModal.setAttribute('aria-hidden', false);
        }
      }
    }, {
      key: "zoomModal",
      value: function zoomModal() {
        var _this6 = this;

        // Open Modal
        this.$zoom.addEventListener('click', function (e) {
          if (e.target.dataset.zoomIndex === undefined) return; // for slides like the video cover that have no corresponding zoom picture

          window.scroll(0, 0);
          e.preventDefault();

          if (window.matchMedia(_this6.flickityBreakpoint).matches) {
            if (typeof _this6.flickityCarousel === 'undefined') {
              _this6.zoomOpen(e);
            }
          } else {
            _this6.zoomOpen(e);
          }
        });

        if (this.flickityCarousel) {
          this.flickityCarousel.on('staticClick', function (e) {
            if (e.target.hasAttribute('data-product-zoom')) {
              _this6.zoomOpen(e);
            }
          });
        } // Close Modal


        this.$zoomClose.addEventListener('click', function () {
          _this6.zoomClose();
        }); // Close with esc key

        document.addEventListener('keyup', function (e) {
          if (e.key === 'Escape') {
            _this6.zoomClose();
          }
        });
      }
    }, {
      key: "zoomClose",
      value: function zoomClose() {
        var _this7 = this;

        document.body.classList.remove('zoom--active');
        this.$zoomModal.classList.remove('active');
        this.$zoomModal.setAttribute('aria-hidden', true);
        var modalContent = document.querySelector("[data-zoom-list]");
        document.querySelector('body').style.overflow = 'auto';

        if (modalContent) {
          modalContent.innerHTML = "";
        }

        setTimeout(function () {
          _this7.$zoomList.animate({
            scrollTop: 0
          }, 0);
        }, 400);
        this.zoomIndexOld = this.zoomIndex;
      }
    }]);

    return PdpImageCarousel;
  }();

  window.pdpImageCarousel = new PdpImageCarousel();

  function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

  function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

  function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
  /* global window */

  /* eslint-disable */

  var Product = /*#__PURE__*/function () {
    function Product() {
      _classCallCheck$1(this, Product);

      this.variantBench = document.querySelector('[data-variant-bench]');
      this.activeProduct = window.activeProduct && window.activeProduct;
      this.activeVariant = window.activeVariant && window.activeVariant;
      this.buyButtons = document.querySelectorAll('.product__form [data-add-to-cart]');
      this.pairsWellWith = document.querySelector('[data-pairs-well-with]');
      this.$insightsUnderline = document.querySelector('[data-product-insights-underline]');
      this.$shareButton = document.querySelector('#socialShareButton');
      this.$socialShareModal = document.querySelector("#socialShareModal");
      this.$closeShareModal = document.querySelector("#closeShareModal");
      this.$shareModalLightBox = document.querySelector('[data-share-modal-lightbox]');
      this.$mainTag = document.getElementById("MainContent");
      this.videoId = null;
      this.init();
    }

    _createClass$1(Product, [{
      key: "init",
      value: function init() {
        // Add to cart form
        this.$form = document.querySelector('form[action="/cart/add"]');
        if (this.$form === null) return;

        if (location.search.includes('video=')) {
          var id = location.search.split('video=')[1];
          this.videoId = id.split('&')[0];
        }

        this.els();
        this.events();
        this.setWaitlistButtonVisibility(true);
      }
    }, {
      key: "setupPairsLinks",
      value: function setupPairsLinks() {
        var links = document.querySelectorAll('[data-just-link]');

        if (links) {
          var _iterator = _createForOfIteratorHelper(links),
              _step;

          try {
            var _loop = function _loop() {
              var link = _step.value;
              link.addEventListener('click', function (e) {
                var location = link.getAttribute('data-just-link');
                window.location = location;
              });
            };

            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              _loop();
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
      }
    }, {
      key: "updateUI",
      value: function updateUI() {
        var _this = this;

        var activeVariant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.activeVariant;

        if (activeVariant) {
          // update variant url
          if (history.pushState) {
            var url = new URL(window.location.href);
            var params = new URLSearchParams(url.search);
            params.set('variant', activeVariant.id);
            url.search = params.toString();
            window.history.pushState({
              path: url.href
            }, '', url.href); // const newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + `?variant=${activeVariant.id}`
            // window.history.replaceState({ path: newurl }, '', newurl)
          } // setup buy button


          this.buyButtons.forEach(function (el) {
            el.dataset.addToCart = _this.activeVariant.id;
            var buttonText = el.querySelector('[data-product-button-text]');

            if (_this.activeVariant.available) {
              buttonText.innerHTML = window.theme.strings.addToCart;
              el.classList.remove('klaviyo-bis-trigger');
            } else {
              var soldOutButtonText = "".concat(window.theme.strings.soldOut, " <span class=\"button__text--email-me\">").concat(window.theme.strings.emailMe, "</span>");

              if (_this.activeProduct.tags.join('|').toLowerCase().includes('coming soon')) {
                soldOutButtonText = window.theme.strings.notifyMe;
              }

              buttonText.innerHTML = soldOutButtonText;
              el.classList.add('klaviyo-bis-trigger');
            }
          }); // show compare-at price if current price is lower

          if (this.activeVariant.price < this.activeVariant.compare_at_price) {
            document.querySelector('[data-compare-price]').classList.remove('visually-hidden');
          } else {
            document.querySelector('[data-compare-price]').classList.add('visually-hidden');
          }
        }
      }
    }, {
      key: "els",
      value: function els() {
        this.$doc = document;
        this.$html = document.querySelector('html');
        this.$win = window; // not used
        //this.id = this.$form.data('product-form')
        // Add to cart button

        this.$buyButton = this.$form.querySelector('[data-add-to-cart]');
        this.$accordionToggles = document.querySelectorAll("[data-accordion-toggle]"); // Swatches

        this.$productSwatches = document.querySelectorAll('[data-product-swatches]'); // Ingredients

        this.$ingredients = document.querySelector('[data-product-ingredients]');
        this.$accordionSection = document.querySelectorAll('[data-accordion-section]');
        if (this.$ingredients === null) return;
        this.$ingredientsCopy = this.$ingredients.querySelector('[data-accordion-copy-text]');
        this.$ingredientsFull = this.$ingredients.querySelector('[data-accordion-hidden-copy]');
        this.$ingredientsFullToggle = this.$ingredients.querySelector('[data-accordion-hidden-toggle]');
      }
    }, {
      key: "events",
      value: function events() {
        this.onVariantChange();
        this.updateIngredients();
        this.toggleAccordion();
        this.insightsVideoPlay();
        this.scrollToReview();
        this.capitalizedPosterString();
        this.initializeUnderline();
        this.updateUI();
        this.updateVariantName();
        this.updateShadeInfo();
        this.setupPairsLinks();
        this.videoOnLoad();
        this.setupStickyAddToCartObserver();
        this.productIngredient();
        this.openVariantChooser();
        this.openSocialShare();
        this.copyURI();
      }
    }, {
      key: "checkNavCarouselLength",
      value: function checkNavCarouselLength() {
        return document.querySelectorAll('.product__thumbs .product__thumb-container').length > 6 ? true : false;
      }
    }, {
      key: "productIngredient",
      value: function productIngredient() {
        var _this2 = this;

        if (this.$accordionSection) {
          /* auto-open on mobile, disabled for now
          if (!window.matchMedia(this.flickityBreakpoint).matches) {
            this.$accordionSection.forEach((element) => {
              element.classList.add('open')
            })
          }
          */
          this.$accordionSection.forEach(function (element) {
            element.addEventListener('click', function () {
              element.classList.toggle('open');

              if (!window.matchMedia(_this2.flickityBreakpoint).matches) {
                setTimeout(function () {
                  accordionSection.classList.toggle('open');
                }, 1000);
              }
            });
          });
        }
      }
    }, {
      key: "setWaitlistButtonVisibility",
      value: function setWaitlistButtonVisibility() {
        // can run this outside of event listener to set correct button states based on currently selected variant
        // - i.e. not be tied to event listener, just get currently selected variant and set button states
        // - note this only runs on product template, so can use that assumption
        // - also note there are two waitlist buttons and two add-to-cart buttons, one in .product__selects and one "sticky" floating button
        var waitlistButtons = document.querySelectorAll('[data-waitlist-button]');
        var buyButtons = document.querySelectorAll('[data-add-to-cart]');
        var selectedVariant = document.querySelector(".product__swatches .product__radios input:checked");
        var isWaitlisted = selectedVariant && selectedVariant.dataset.waitlistFormId != undefined;

        var _iterator2 = _createForOfIteratorHelper(waitlistButtons),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var btn = _step2.value;

            // ignore waitlist buttons inside 'pairs with' product tiles
            if (btn.closest('.product-tile--pairs') || btn.closest('[data-pairs-well-with]')) {
              continue;
            }

            if (selectedVariant && isWaitlisted) {
              btn.dataset.waitlistFormId = selectedVariant.dataset.waitlistFormId;
              btn.querySelector('[data-waitlist-mobile]').innerText = selectedVariant.dataset.waitlistMobileText;
              btn.querySelector('[data-waitlist-desktop]').innerText = selectedVariant.dataset.waitlistDesktopText;
              btn.style.display = "block";
            } else if (btn.dataset.waitlistFormId) {
              btn.querySelector('[data-waitlist-mobile]').innerText = selectedVariant.dataset.waitlistMobileText;
              btn.querySelector('[data-waitlist-desktop]').innerText = selectedVariant.dataset.waitlistDesktopText;
              btn.style.display = "block";
            } else {
              btn.style.display = "none";
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        var _iterator3 = _createForOfIteratorHelper(buyButtons),
            _step3;

        try {
          var _loop2 = function _loop2() {
            var btn = _step3.value;
            return "continue"; // watch for style changes to force buy button state
            // FIXME this is a hack, something is changing the buy button display style but I can't find it :(

            var obs = new MutationObserver(function (records, obs) {
              var _iterator4 = _createForOfIteratorHelper(records),
                  _step4;

              try {
                for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                  var record = _step4.value;

                  if (record.type === 'attributes' && record.attributeName === 'style') {
                    if (isWaitlisted && record.target.style.display !== 'none') {
                      btn.style.display = 'none';
                      obs.disconnect();
                    } else if (!isWaitlisted && record.target.style.display !== 'block') {
                      btn.style.display = 'block';
                      obs.disconnect();
                    }
                  }
                }
              } catch (err) {
                _iterator4.e(err);
              } finally {
                _iterator4.f();
              }
            });
            btn.style.display = isWaitlisted ? "none" : "block";
            obs.observe(btn, {
              attributes: true,
              childList: true,
              subtree: true
            });
            setTimeout(function () {
              btn.style.display = isWaitlisted ? "none" : "block";
            }, 5);
          };

          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _ret = _loop2();

            if (_ret === "continue") continue;
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
    }, {
      key: "onVariantChange",
      value: function onVariantChange() {
        var _this3 = this;

        this.variantSelectInputs = document.querySelectorAll('[data-variant-swatch]');

        var _iterator5 = _createForOfIteratorHelper(this.variantSelectInputs.entries()),
            _step5;

        try {
          var _loop3 = function _loop3() {
            var _step5$value = _slicedToArray(_step5.value, 2),
                index = _step5$value[0],
                input = _step5$value[1];

            input.addEventListener('click', function (e) {
              _this3.setWaitlistButtonVisibility();

              _this3.activeVariant = _this3.activeProduct.variants.find(function (el) {
                return el.option1 === input.getAttribute("value");
              });

              _this3.updateUI(); // replacement for updateImages call, since that has moved to pdp-image-carousel.js


              window.eventBus.pub('variant:changed', input.dataset.colorHandle); //this.updateImages(input.dataset.colorHandle)

              _this3.updateIngredients();

              var updatedTitle = input.getAttribute("value");
              var updateText = input.getAttribute('data-shade-info');

              if (!updateText) {
                updateText = updatedTitle;
              }

              var updatedImageUrl = input.getAttribute("data-variant-image-url");
              var updatedDescription = input.getAttribute("data-variant-extra-copy");
              var availableVariant = input.getAttribute("data-variant-available"); // Checking the clicked is input variant or chooser variant

              if (input.dataset['variantSelector']) {
                _this3.updateActiveShade(updateText, updatedDescription, updatedImageUrl, availableVariant);

                _this3.updateSelectedInTheChooser(updatedTitle, input);
              } else {
                _this3.updateActiveShadeChooser(updateText, updatedDescription, updatedImageUrl, input, availableVariant);
              } // Update the sticky add to bag selected image and variant


              _this3.updateSelectedInTheSticky(updatedTitle, updatedImageUrl);

              _this3.updatePrice(input.dataset.price, input.dataset.compareAtPrice);

              _this3.updateCta(input.dataset.price, input.dataset.compareAtPrice);
            });
          };

          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            _loop3();
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      }
    }, {
      key: "updateCta",
      value: function updateCta(price, compareAtPrice) {
        var priceEls = document.querySelectorAll('form .product__price'); // if price < compareAtPrice, show el.children[1] (strikethrough compare-at price)
        // else hide el.children[1]

        var _iterator6 = _createForOfIteratorHelper(priceEls),
            _step6;

        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var el = _step6.value;
            var newPrice = Number(price);
            var newComparePrice = Number(compareAtPrice);
            var priceEl = el.querySelector('[data-cta-price]');
            var comparePriceEl = el.querySelector('[data-cta-compare-price]'); // check if metaobject price override

            if (el.querySelector('[data-compare-override]')) {
              comparePriceEl = el.querySelector('[data-compare-override]');
              priceEl = el.querySelector('[data-price-override]'); // if override is set, just preserve the existing prices

              return;
            } // set new price and compare-at price


            if (comparePriceEl) {
              comparePriceEl.innerHTML = Shopify.formatMoney(newComparePrice, window.theme.moneyFormat).replace('.00', '');
            }

            if (priceEl) {
              priceEl.innerHTML = Shopify.formatMoney(newPrice, window.theme.moneyFormat).replace('.00', '');
            }

            if (newPrice < newComparePrice) {
              if (comparePriceEl) {
                comparePriceEl.classList.remove('visually-hidden');
              } // set main price color style to inherit


              if (priceEl) {
                priceEl.style.color = 'inherit';
              }
            } else {
              if (comparePriceEl) {
                comparePriceEl.classList.add('visually-hidden');
              }

              if (priceEl) {
                priceEl.style.color = 'white';
              }
            }
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
      }
    }, {
      key: "updatePrice",
      value: function updatePrice(price, comparePrice) {
        var priceEl = document.querySelector('[data-product-price]');
        var comparePriceEl = document.querySelector('[data-compare-price]'); // only show compare price if higher than current price

        if (price >= comparePrice) {
          comparePriceEl.classList.add('visually-hidden');
        } else {
          comparePriceEl.classList.remove('visually-hidden');
        } // format price to money, dropping zeros if no cents on USD, converting to foreign currency if needed


        var currencyCode = document.body.dataset['currencyCode'];
        var currencySymbol = document.body.dataset['currencySymbol'];
        var displayPrice, displayComparePrice;

        if (currencyCode === 'USD') {
          displayPrice = price % 100 > 0 ? "$".concat((price / 100).toFixed(2)) : "$".concat(price / 100);
          displayComparePrice = comparePrice % 100 > 0 ? "$".concat((comparePrice / 100).toFixed(2)) : "$".concat(comparePrice / 100);
        } else if (currencyCode !== 'USD' && currencySymbol == '$') {
          displayPrice = Shopify.formatMoney(price, "".concat(currencyCode, " ").concat(currencySymbol, " {{ amount_no_decimals }}"));
          displayComparePrice = Shopify.formatMoney(comparePrice, "".concat(currencyCode, " ").concat(currencySymbol, " {{ amount_no_decimals }}"));
        } else {
          displayPrice = Shopify.formatMoney(price, "".concat(currencySymbol, " {{ amount_with_comma_separator }}"));
          displayComparePrice = Shopify.formatMoney(comparePrice, "".concat(currencySymbol, " {{ amount_with_comma_separator }}"));
        }

        if (price) {
          priceEl.innerHTML = displayPrice;
        }

        if (comparePrice) {
          comparePriceEl.innerHTML = displayComparePrice;
        }
      }
    }, {
      key: "updateActiveShade",
      value: function updateActiveShade(title, description, imageUrl, availableVariant) {
        var selectedDetails = document.querySelector("[data-selected-variant-details]");
        var selectedColor = document.getElementById("variant_chooser_item_color");
        var selectedDescription = document.querySelector("[data-selected-variant-description]");

        if (!selectedDetails) {
          selectedDetails = document.querySelector('[data-variant-selected]');
        }

        if (selectedDetails) {
          selectedDetails.setAttribute("data-selected-variant-details", title);
        }

        if (selectedDescription) {
          selectedDescription.setAttribute("data-selected-variant-description", description);
        }

        if (selectedColor) {
          selectedColor.setAttribute("data-variant-image-url", imageUrl);
          selectedColor.setAttribute("data-variant-available", availableVariant);
        }
      }
    }, {
      key: "updateIngredients",
      value: function updateIngredients() {
        if (this.$ingredients === null) return;
        this.$ingredientsFull.removeClass('active');
        var v_ingredients = window.ingredients.variants[this.activeVariant.id];

        if (v_ingredients.copy !== null) {
          this.$ingredientsCopy.html(v_ingredients.copy);
          this.$ingredientsFull.html(v_ingredients.full !== null ? v_ingredients.full : '');

          if (v_ingredients.full !== null) {
            this.$ingredientsFullToggle.removeClass('hidden');
          } else {
            this.$ingredientsFullToggle.addClass('hidden');
          }
        } else {
          this.$ingredientsCopy.html(window.ingredients.copy !== null ? window.ingredients.copy : '');
          this.$ingredientsFull.html(window.ingredients.full !== null ? window.ingredients.full : '');

          if (this.$ingredientsFull !== null) {
            this.$ingredientsFullToggle.removeClass('hidden');
          } else {
            this.$ingredientsFullToggle.addClass('hidden');
          }
        }
      }
    }, {
      key: "initializeUnderline",
      value: function initializeUnderline() {
        var _this4 = this;

        if (this.$insightsUnderline) {
          this.tabLinks = document.querySelectorAll('[data-product-insights-tab-link]');
          this.firstLink = document.querySelector('[data-product-insights-tab-link]:first-child');

          if (this.firstLink) {
            this.updateUnderline(this.firstLink);
          }

          this.$insightsUnderline.style.opacity = "1";

          if (this.tabLinks) {
            this.tabLinks.forEach(function (link) {
              link.addEventListener("click", function (event) {
                event.preventDefault();

                _this4.updateUnderline(link);

                var targetSectionId = link.getAttribute("href").substring(1);

                _this4.scrollToSection(targetSectionId);
              });
            });
          }
        }
      }
    }, {
      key: "removeActiveClass",
      value: function removeActiveClass() {
        if (this.tabLinks) {
          this.tabLinks.forEach(function (link) {
            link.classList.remove("active-tab");
          });
        }
      }
    }, {
      key: "scrollToSection",
      value: function scrollToSection(sectionId) {
        var _this5 = this;

        var section = document.getElementById(sectionId);

        if (section) {
          setTimeout(function () {
            section.scrollIntoView({
              behavior: "smooth"
            });

            if (_this5.firstLink) {
              setTimeout(function () {
                _this5.updateUnderline(_this5.firstLink);
              }, 1500);
            }
          }, 1000);
        }
      }
    }, {
      key: "updateUnderline",
      value: function updateUnderline(link) {
        if (link) {
          this.removeActiveClass();
          var linkRect = link.getBoundingClientRect();
          link.classList.add("active-tab");
          this.$insightsUnderline.style.width = "".concat(linkRect.width, "px");
          this.$insightsUnderline.style.transform = "translateX(".concat(linkRect.left, "px)");
        }
      }
    }, {
      key: "toggleAccordion",
      value: function toggleAccordion() {
        if (this.$accordionToggles) {
          this.$accordionToggles.forEach(function (toggle) {
            toggle.addEventListener("click", function () {
              var parentDiv = toggle.closest(".product-accordion__item");

              if (parentDiv) {
                parentDiv.classList.toggle("active");
              }
            });
          });
        }
      }
    }, {
      key: "scrollToReview",
      value: function scrollToReview() {
        var productRatingLink = document.getElementById("productRatingSection");
        var targetSection = document.getElementById("okeReviewsWidgetContainer");

        if (productRatingLink && targetSection) {
          productRatingLink.addEventListener('click', function () {
            targetSection.scrollIntoView({
              behavior: 'smooth'
            });
          });
        }
      }
    }, {
      key: "insightsVideoPlay",
      value: function insightsVideoPlay() {
        var iframe = document.querySelector("[data-product-insights-video] iframe");
        var posterImage = document.querySelector("[data-product-insights-poster]");

        if (posterImage && iframe) {
          posterImage.addEventListener("click", function () {
            var src = iframe.src;

            if (src.includes("?")) {
              iframe.src = src + "&autoplay=1";
            } else {
              iframe.src = src + "?autoplay=1";
            }

            posterImage.style.display = 'none';
          });
        }
      }
    }, {
      key: "capitalizedPosterString",
      value: function capitalizedPosterString() {
        var spanElement = document.querySelector("[data-poster-short-description]");

        if (spanElement) {
          var text = spanElement.textContent;
          var words = text.split(" ");
          var capitalizedWords = words.map(function (word) {
            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
          });
          spanElement.textContent = capitalizedWords.join(" ");
        }
      }
    }, {
      key: "updateVariantName",
      value: function updateVariantName() {
        // show variant name, description and image on hover for the not-shade products
        var titleTarget = document.querySelector('[data-variant-selected]');
        var descriptionTarget = document.querySelector("[data-selected-variant-description]");
        var imageTarget = document.getElementById("variant_chooser_item_color");
        var swatchInputs = document.querySelectorAll('[data-variant-swatch]:not(.product__radio-input--shade)');

        if (swatchInputs) {
          var _iterator7 = _createForOfIteratorHelper(swatchInputs),
              _step7;

          try {
            var _loop4 = function _loop4() {
              var input = _step7.value;
              input.addEventListener('mouseenter', function () {
                if (titleTarget) {
                  titleTarget.innerHTML = input.value;
                }

                if (descriptionTarget) {
                  descriptionTarget.innerHTML = input.getAttribute("data-variant-extra-copy");
                }

                if (imageTarget) {
                  imageTarget.style.backgroundImage = input.getAttribute("data-variant-image-url");
                  var disabledRadio = input.closest('.product__radio--disabled');

                  if (disabledRadio) {
                    imageTarget.classList.add('disabled');
                  } else {
                    imageTarget.classList.remove("disabled");
                  }
                }
              });
              input.addEventListener('mouseleave', function () {
                if (descriptionTarget) {
                  var description = descriptionTarget.getAttribute("data-selected-variant-description");
                  descriptionTarget.innerHTML = description;
                }

                if (titleTarget) {
                  var text = titleTarget.getAttribute("data-selected-variant-details");
                  titleTarget.innerHTML = text;
                }

                if (imageTarget) {
                  var imageUrl = imageTarget.getAttribute("data-variant-image-url");
                  imageTarget.style.backgroundImage = imageUrl;
                  var availableVariant = imageTarget.getAttribute("data-variant-available");

                  if (availableVariant == "true") {
                    imageTarget.classList.remove("disabled");
                  } else {
                    imageTarget.classList.add("disabled");
                  }
                }
              });
            };

            for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
              _loop4();
            }
          } catch (err) {
            _iterator7.e(err);
          } finally {
            _iterator7.f();
          }
        }
      }
    }, {
      key: "updateShadeInfo",
      value: function updateShadeInfo() {
        var _this6 = this;

        // show shade short info on hover
        var target = document.querySelector('[data-selected-variant-details]');
        var descriptionTarget = document.querySelector('[data-selected-variant-description]');
        var imageTarget = document.getElementById('variant_chooser_item_color');
        var swatchInputs = document.querySelectorAll('[data-variant-swatch]');
        var swatchOptions = document.querySelectorAll('[data-variant-chooser-item-wrapper]:not([data-wrapper-display])');

        if (target && swatchInputs && imageTarget) {
          var _iterator8 = _createForOfIteratorHelper(swatchInputs),
              _step8;

          try {
            var _loop5 = function _loop5() {
              var input = _step8.value;
              input.addEventListener("mouseenter", function () {
                var text = input.getAttribute("data-shade-info");

                if (target) {
                  target.innerHTML = target.getAttribute("data-variant-text") + " " + text;
                }

                if (descriptionTarget) {
                  descriptionTarget.innerHTML = input.getAttribute("data-variant-extra-copy");
                }

                imageTarget.style.backgroundImage = input.getAttribute("data-variant-image-url");
                var disabledRadio = input.closest('.product__radio--disabled');

                if (disabledRadio) {
                  imageTarget.classList.add('disabled');
                } else {
                  imageTarget.classList.remove("disabled");
                }
              });
              input.addEventListener("mouseleave", function () {
                var text = target.getAttribute("data-selected-variant-details");
                var imageUrl = imageTarget.getAttribute("data-variant-image-url");
                target.innerHTML = text;
                imageTarget.style.backgroundImage = imageUrl;
                var availableVariant = imageTarget.getAttribute("data-variant-available");

                if (availableVariant == "true") {
                  imageTarget.classList.remove("disabled");
                } else {
                  imageTarget.classList.add("disabled");
                }

                if (descriptionTarget) {
                  var description = descriptionTarget.getAttribute('data-selected-variant-description');
                  descriptionTarget.innerHTML = description;
                }
              });
            };

            for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
              _loop5();
            }
          } catch (err) {
            _iterator8.e(err);
          } finally {
            _iterator8.f();
          }
        }

        var selectedToneFam = 'all';
        var selectedUndertone = 'all';
        var toneFamTabs = document.querySelectorAll('[data-tone-family-buttons] a');
        var undertoneTabs = document.querySelectorAll('[data-shade-undertone-tab] a');
        var undertoneGroups = document.querySelectorAll('[data-undertone-group]');

        var filterSwatches = function filterSwatches(fam, tone, options) {
          var swatchs = swatchInputs;
          if (options && swatchOptions) swatchs = swatchOptions;

          var _iterator9 = _createForOfIteratorHelper(swatchs),
              _step9;

          try {
            for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
              var input = _step9.value;
              var element = input.parentElement;
              if (options && swatchOptions) element = input;

              var _f = void 0;

              try {
                _f = input.getAttribute('data-shade-fam').split('|');
              } catch (error) {
                console.log(error);
              }

              var _t = input.getAttribute('data-shade-undertone');

              var alt_families = input.getAttribute('data-alt-fam');

              var _alt = void 0;

              if (alt_families) {
                _alt = alt_families.split('-').map(function (el) {
                  return el.replace('_', '-');
                });
              }

              if (fam !== 'all' && tone === 'all') {
                if (_f.includes(fam)) {
                  element.classList.remove('hide');
                } else {
                  element.classList.add('hide');
                }

                if (_alt && _alt.includes(fam)) {
                  element.classList.remove('hide');
                }
              } else if (fam === 'all' && tone !== 'all') {
                if (tone === _t) {
                  element.classList.remove('hide');
                } else {
                  element.classList.add('hide');
                }
              } else if (fam !== 'all' && tone === 'all') {
                if (_f.includes(fam)) {
                  element.classList.remove('hide');
                } else {
                  element.classList.add('hide');
                }
              } else if (fam !== 'all' && tone !== 'all') {
                element.classList.remove('hide');

                if (_f.includes(fam) && tone === _t) {} else {
                  element.classList.add('hide');
                }
              } else if (fam !== 'all' && _alt[0] !== '') {
                element.classList.add('hide');

                if (_f.includes(fam) || _alt.includes(fam)) {
                  element.classList.remove('hide');
                }
              } else {
                element.classList.remove('hide');
              }
            }
          } catch (err) {
            _iterator9.e(err);
          } finally {
            _iterator9.f();
          }

          if (!options) selectFirstSwatch();
        };

        var clearToneFamTabs = function clearToneFamTabs() {
          var _iterator10 = _createForOfIteratorHelper(toneFamTabs),
              _step10;

          try {
            for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
              var tone = _step10.value;
              tone.classList.remove('active');
            }
          } catch (err) {
            _iterator10.e(err);
          } finally {
            _iterator10.f();
          }
        };

        var clearUndertoneTabs = function clearUndertoneTabs() {
          var _iterator11 = _createForOfIteratorHelper(undertoneTabs),
              _step11;

          try {
            for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
              var tone = _step11.value;
              tone.classList.remove('active');
            }
          } catch (err) {
            _iterator11.e(err);
          } finally {
            _iterator11.f();
          }
        };

        var selectFirstSwatch = function selectFirstSwatch() {
          var firstVisibleRadio = document.querySelector('.product__info .product__radio:not(.hide) .product__radio-input.product__radio-input--shade');
          var shadeElement = document.querySelector('[data-selected-variant-details]');
          var chooserColorImage = document.getElementById('variant_chooser_item_color');
          var chooserDescription = document.querySelector('[data-selected-variant-description]');
          var shadeText = "";

          if (shadeElement) {
            shadeText = shadeElement.getAttribute('data-variant-text');
          }

          if (firstVisibleRadio) {
            _this6.activeVariant = _this6.activeProduct.variants.find(function (el) {
              return el.title === firstVisibleRadio.dataset.shadeInfo;
            });

            _this6.updateUI();

            window.eventBus.pub('variant:changed', firstVisibleRadio.dataset.colorHandle); //this.updateImages(firstVisibleRadio.dataset.colorHandle)

            _this6.updateIngredients();

            _this6.updateActiveShade(shadeText + " " + firstVisibleRadio.getAttribute("data-shade-info"), firstVisibleRadio.getAttribute("data-variant-extra-copy"), firstVisibleRadio.getAttribute("data-variant-image-url"));

            firstVisibleRadio.checked = true;
            document.querySelector('[data-selected-variant-details]').innerHTML = shadeText + " " + firstVisibleRadio.dataset.shadeInfo;

            if (chooserColorImage) {
              chooserColorImage.style.backgroundImage = firstVisibleRadio.dataset.variantImageUrl;
            }

            if (chooserDescription) {
              chooserDescription.innerHTML = firstVisibleRadio.dataset.variantExtraCopy;
            }

            _this6.updateSelectedInTheChooser(firstVisibleRadio.value, firstVisibleRadio);
          }
        };

        var skinToneSelect = document.querySelector('[data-skintone-select]');
        var undertoneSelects = document.querySelectorAll('[data-select-group]');

        var _iterator12 = _createForOfIteratorHelper(toneFamTabs),
            _step12;

        try {
          var _loop6 = function _loop6() {
            var tab = _step12.value;
            tab.addEventListener('click', function (e) {
              e.preventDefault();
              selectedToneFam = tab.getAttribute('data-tone-fam');
              if (selectedToneFam === 'all') selectedUndertone = 'all';
              filterSwatches(selectedToneFam, selectedUndertone);
              filterSwatches(selectedToneFam, selectedUndertone, true);
              clearToneFamTabs();
              tab.classList.add('active');

              var _iterator19 = _createForOfIteratorHelper(undertoneGroups),
                  _step19;

              try {
                for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
                  var group = _step19.value;
                  group.classList.remove('active');
                  var groupTitle = group.getAttribute('data-undertone-group');

                  if (groupTitle === selectedToneFam) {
                    group.classList.add('active');
                    var firstLink = group.querySelector('a');

                    if (firstLink) {
                      firstLink.click();
                    }
                  }
                }
              } catch (err) {
                _iterator19.e(err);
              } finally {
                _iterator19.f();
              }

              if (skinToneSelect) {
                for (var i = 0; i < skinToneSelect.options.length; ++i) {
                  if (skinToneSelect.options[i].text === selectedToneFam) {
                    skinToneSelect.options[i].selected = true;
                  }
                }
              }
            });
          };

          for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
            _loop6();
          } // Undertone Actions

        } catch (err) {
          _iterator12.e(err);
        } finally {
          _iterator12.f();
        }

        var _iterator13 = _createForOfIteratorHelper(undertoneTabs),
            _step13;

        try {
          var _loop7 = function _loop7() {
            var tab = _step13.value;
            tab.addEventListener('click', function (e) {
              e.preventDefault();
              selectedUndertone = tab.getAttribute('data-shade-undertone');
              filterSwatches(selectedToneFam, selectedUndertone);
              filterSwatches(selectedToneFam, selectedUndertone, true);
              clearUndertoneTabs();
              tab.classList.add('active');

              var _iterator20 = _createForOfIteratorHelper(undertoneSelects),
                  _step20;

              try {
                for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
                  var group = _step20.value;
                  group.classList.remove('active');
                  var groupTitle = group.getAttribute('data-select-group');

                  if (groupTitle === selectedToneFam) {
                    group.classList.add('active');

                    for (var i = 0; i < group.options.length; ++i) {
                      var formattedText = group.options[i].text.replace(' ', '-').toLowerCase();

                      if (formattedText === selectedUndertone) {
                        group.options[i].selected = true;
                      }
                    }
                  }
                }
              } catch (err) {
                _iterator20.e(err);
              } finally {
                _iterator20.f();
              }
            });
          };

          for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
            _loop7();
          } // -- skin tone selects

        } catch (err) {
          _iterator13.e(err);
        } finally {
          _iterator13.f();
        }

        if (skinToneSelect) {
          skinToneSelect.addEventListener('change', function () {
            //console.log('changed: ', this.value, this.selectedIndex)
            var _iterator14 = _createForOfIteratorHelper(toneFamTabs.entries()),
                _step14;

            try {
              for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
                var _step14$value = _slicedToArray(_step14.value, 2),
                    index = _step14$value[0],
                    tab = _step14$value[1];

                if (index === this.selectedIndex) {
                  tab.click();
                }
              }
            } catch (err) {
              _iterator14.e(err);
            } finally {
              _iterator14.f();
            }

            var _iterator15 = _createForOfIteratorHelper(undertoneGroups),
                _step15;

            try {
              for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
                var group = _step15.value;

                if (group.getAttribute('data-undertone-group') === selectedToneFam) {
                  //console.log('found group: ', group)
                  group.querySelector('a').click();
                }
              }
            } catch (err) {
              _iterator15.e(err);
            } finally {
              _iterator15.f();
            }

            var _iterator16 = _createForOfIteratorHelper(undertoneSelects),
                _step16;

            try {
              for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
                var _group = _step16.value;

                _group.classList.remove('active');

                var groupTitle = _group.getAttribute('data-select-group');

                if (groupTitle === this.value) {
                  _group.classList.add('active');

                  selectedToneFam = this.value;
                  filterSwatches(selectedToneFam, selectedUndertone);
                }
              }
            } catch (err) {
              _iterator16.e(err);
            } finally {
              _iterator16.f();
            }
          });
        } // -- undertone group selects


        if (undertoneSelects.length) {

          var _iterator17 = _createForOfIteratorHelper(undertoneSelects),
              _step17;

          try {
            for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
              var select = _step17.value;
              select.addEventListener('change', function () {
                //console.log('changed undertone: ', this.value)
                selectedUndertone = this.value.replace(' ', '-');
                filterSwatches(selectedToneFam, selectedUndertone);

                var _iterator18 = _createForOfIteratorHelper(undertoneTabs.entries()),
                    _step18;

                try {
                  for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
                    var _step18$value = _slicedToArray(_step18.value, 2),
                        index = _step18$value[0],
                        tab = _step18$value[1];

                    var tone = tab.getAttribute('data-shade-undertone');
                    tab.classList.remove('active');

                    if (tone === selectedUndertone) {
                      //console.log('matched: ', tone)
                      tab.classList.add('active');
                    }
                  }
                } catch (err) {
                  _iterator18.e(err);
                } finally {
                  _iterator18.f();
                }
              });
            }
          } catch (err) {
            _iterator17.e(err);
          } finally {
            _iterator17.f();
          }
        }
      }
    }, {
      key: "videoOnLoad",
      value: function videoOnLoad() {
        // Open video on page load
        if (this.videoId) {
          //$('.product__thumb-link[data-lity][href*="' + this.videoId + '"]').first().get(0).click()
          document.querySelector('.product__thumb-link[data-lity][href*="' + this.videoId + '"]').click();
        }
      }
    }, {
      key: "setupStickyAddToCartObserver",
      value: function setupStickyAddToCartObserver() {
        var offset = 0;
        var el = document.querySelector('[data-product-button-sticky]');
        var obs = new IntersectionObserver(function (e) {
          if (e[0].isIntersecting) {
            el.setAttribute('aria-hidden', 'false');
          } else {
            el.setAttribute('aria-hidden', 'true');
          }
        }, {
          threshold: offset,
          root: null
        }); // specifying root: null sets the intersection target to the device viewport

        obs.observe(el);
      }
    }, {
      key: "openVariantChooser",
      value: function openVariantChooser() {
        var openChooserWrapper = document.querySelector("#open_variant_chooser");
        var closeChooserWrapper = document.querySelector('[data-chooser-close]');
        var closeChooserButton = document.querySelector('.product__variant-chooser-items-header-close');

        if (openChooserWrapper) {
          openChooserWrapper.addEventListener("click", this.toggleChooserItems);
        }

        if (closeChooserWrapper) {
          closeChooserWrapper.addEventListener("click", this.toggleChooserItems);
        }

        if (closeChooserButton) {
          closeChooserButton.addEventListener("click", this.toggleChooserItems);
        }

        document.body.addEventListener('click', this.hideChooserItems.bind(this));
      }
    }, {
      key: "hideChooserItems",
      value: function hideChooserItems(event) {
        var chooserItemsWrapper = document.querySelector('[data-variant-chooser-items]');

        if (chooserItemsWrapper) {
          if (!chooserItemsWrapper.classList.contains("hide") && event.target.closest("#open_variant_chooser") == null && event.target.closest(".product__variant-chooser-items-content") == null) {
            this.toggleChooserItems();
          }
        }
      }
    }, {
      key: "toggleChooserItems",
      value: function toggleChooserItems() {
        var chooserItemsWrapper = document.querySelector('[data-variant-chooser-items]');
        var arrowDown = document.querySelector('[data-arrow-down]');
        var arrowUp = document.querySelector('[data-arrow-up]');
        var windowWidth = window.innerWidth;

        if (chooserItemsWrapper) {
          chooserItemsWrapper.classList.toggle("hide");
        }

        if (document.body && windowWidth < 1200) {
          document.body.classList.toggle("chooser-opened");
        }

        if (arrowDown && arrowUp) {
          arrowDown.classList.toggle("hide");
          arrowUp.classList.toggle("hide");
        }
      }
    }, {
      key: "openSocialShare",
      value: function openSocialShare() {
        var _this7 = this;

        if (this.$shareButton && this.$socialShareModal) {
          this.$shareButton.addEventListener('click', function () {
            _this7.$socialShareModal.classList.remove('hide');

            if (document.body) {
              document.body.classList.add("noscroll");
            }

            if (_this7.$shareModalLightBox) {
              _this7.$shareModalLightBox.classList.add("showLightbox");
            }

            if (_this7.$mainTag) {
              _this7.$mainTag.classList.add("modal-shown");
            }
          });

          if (this.$shareModalLightBox) {
            this.$shareModalLightBox.addEventListener('click', function () {
              _this7.hideShareModal();
            });
          }

          if (this.$closeShareModal) {
            this.$closeShareModal.addEventListener("click", function () {
              _this7.hideShareModal();
            });
          }
        }
      }
    }, {
      key: "hideShareModal",
      value: function hideShareModal() {
        this.$socialShareModal.classList.add("hide");

        if (document.body) {
          document.body.classList.remove("noscroll");
        }

        if (this.$shareModalLightBox) {
          this.$shareModalLightBox.classList.remove("showLightbox");
        }

        if (this.$mainTag) {
          this.$mainTag.classList.remove("modal-shown");
        }
      }
    }, {
      key: "copyURI",
      value: function copyURI() {
        var shareCopyLink = document.querySelector("#shareCopyLink");

        if (shareCopyLink) {
          shareCopyLink.addEventListener('click', function (e) {
            e.preventDefault();
            var tooltip = document.getElementById("shareCopyTooltip");
            navigator.clipboard.writeText(e.currentTarget.getAttribute('href')).then(function () {
              if (tooltip) {
                tooltip.innerHTML = "Copied";
                tooltip.classList.add('show');
              }
            }, function () {
              /* clipboard write failed */
              console.log("Unable to Copy the link to Clipboard");
            });
            setTimeout(function () {
              if (tooltip) {
                tooltip.classList.remove("show");
              }
            }, 2000);
          });
        }
      } // On the chooser drop down item click

    }, {
      key: "updateActiveShadeChooser",
      value: function updateActiveShadeChooser(title, description, imageUrl, element, availableVariant) {
        var selectedDetails = document.querySelector('[data-selected-variant-details]');
        var selectedColor = document.getElementById('variant_chooser_item_color');
        var selectedDescription = document.querySelector('[data-selected-variant-description]');
        var arrowUp = document.querySelector('[data-arrow-up]');
        var arrowDown = document.querySelector('[data-arrow-down]');

        if (!selectedDetails) {
          selectedDetails = document.querySelector("[data-variant-selected]");
        } // Set the title for the shown item of the chooser dropdown


        if (selectedDetails) {
          selectedDetails.setAttribute("data-selected-variant-details", title);
          selectedDetails.innerHTML = title;
        } // Set the description for the shown item of the chooser dropdown


        if (selectedDescription) {
          selectedDescription.setAttribute("data-selected-variant-description", description);
          selectedDescription.innerHTML = description;
        } // Set the color image for the shown item of the chooser dropdown


        if (selectedColor) {
          selectedColor.setAttribute("data-variant-image-url", imageUrl);
          selectedColor.style.backgroundImage = imageUrl;
          selectedColor.setAttribute("data-variant-available", availableVariant);
        }

        var clickedChooserValue = element.getAttribute('value');
        var inputVariants = document.querySelectorAll('input.product__radio-input');
        var chooserItemsWrapper = document.querySelector('[data-variant-chooser-items]');
        var body = document.querySelector("body");
        var windowWidth = window.innerWidth;

        if (chooserItemsWrapper) {
          chooserItemsWrapper.classList.toggle('hide');
        }

        if (body && windowWidth < 1200) {
          body.classList.toggle("chooser-opened");
        }

        if (arrowDown && arrowUp) {
          arrowDown.classList.toggle('hide');
          arrowUp.classList.toggle("hide");
        }

        if (clickedChooserValue) {
          this.updateSelectedInTheChooser(clickedChooserValue, element);
        }

        if (inputVariants && clickedChooserValue) {
          var _iterator21 = _createForOfIteratorHelper(inputVariants.entries()),
              _step21;

          try {
            for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
              var _step21$value = _slicedToArray(_step21.value, 2),
                  index = _step21$value[0],
                  input = _step21$value[1];

              if (input.getAttribute('value') === clickedChooserValue) {
                if (this.activeVariant) {
                  this.activeVariant = this.activeProduct.variants[index];
                  input.checked = true;
                }
              } else {
                input.checked = false;
              }
            }
          } catch (err) {
            _iterator21.e(err);
          } finally {
            _iterator21.f();
          }
        }
      } // Update the selected item classes in the chooser dropdown

    }, {
      key: "updateSelectedInTheChooser",
      value: function updateSelectedInTheChooser(clickedValue, element) {
        var chooserItem = document.querySelectorAll('[data-variant-chooser-item-wrapper]');
        var selectedColor = document.getElementById("variant_chooser_item_color");
        var isVarentAvailable = element.getAttribute('data-variant-available'); // Set the chooser variant class to selected and remove the previous selected chooser variant

        chooserItem.forEach(function (item) {
          item.classList.remove("selected");

          if (item.getAttribute('value') === clickedValue) {
            item.classList.add("selected");
          }
        });

        if (isVarentAvailable === 'true') {
          selectedColor.classList.remove('disabled');
        } else {
          selectedColor.classList.add('disabled');
        }
      }
    }, {
      key: "updateSelectedInTheSticky",
      value: function updateSelectedInTheSticky(title, imageUrl) {
        var stickyVariantImage = document.querySelector("[data-sticky-variant-image-url]");
        var stickyVariantTitle = document.querySelector("[data-sticky-variant-title]");

        if (stickyVariantImage) {
          stickyVariantImage.setAttribute("data-sticky-variant-image-url", imageUrl);
          stickyVariantImage.style.backgroundImage = imageUrl;
        }

        if (stickyVariantTitle) {
          stickyVariantTitle.setAttribute("data-sticky-variant-title", title);
          stickyVariantTitle.innerHTML = title;
        }
      }
    }]);

    return Product;
  }();

  new Product();

})();
